window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  cartData: {},
  updatingCart: false,
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  init: function() {
    $(document).on('click', '[data-cart-open]', slate.cart.openMiniCart.bind(this));

    // Add to Cart
    $(document).on('click', '[data-add-to-cart]', slate.cart.addToCart.bind(this));
    $(window).on('pplrAddToCartCompleted', slate.cart.customizerAddToCart.bind(this));

    // Add Mini Cart YAML to Cart
    $(document).on('click', '[data-add-to-mini-cart]', slate.cart.addToMiniCart.bind(this));

    // Cart Update Line Item Quantity
    $(document).on('click', '[data-quantity-adjust]', slate.cart.quantityAdjust.bind(this));
    $(document).on('blur, change', '[data-quantity-update]', slate.cart.quantityUpdate.bind(this));

    // Cart Remove Line Item
    $(document).on('click', '[data-line-item-remove]', slate.cart.removeLineItemTrigger.bind(this));

    // Close Mini Cart
    $(document).on('click', '[data-mini-cart-close]', slate.cart.closeMiniCart.bind(this));
    $(document).on('click', '[data-mini-cart-overlay]', slate.cart.closeMiniCart.bind(this));

    // Select option from free gift
    $(document).on('change', 'input[type="radio"][data-free-gift-variant]', slate.cart.addFreeGiftToCart.bind(this));
    $(document).on('change', 'input[type="radio"][data-promotional-gift-variant]', slate.cart.addPromotionalGiftToCart.bind(this));

    // Checkout button is clicked
    $(document).on('click', '[name="checkout"]', slate.cart.checkFreeGiftSelected.bind(this));
    $('.cart [data-ymal]').on('click', this.ssClickTrack.bind(this));

    // Get Cart Data
    slate.cart.getCart()

    // Cart Sticky Button
    slate.cart.stickyButton();

    slate.cart.updateMiniCart();
  },
  addProductFromId: function(id, properties = {}) {
    if(id !== null) {
      $.post('/cart/add.js', {
        id: id,
        quantity: 1,
        properties: properties
      }).then(function() {
        slate.cart.updateCartCount();
        slate.cart.updateCart();
        slate.cart.updateMiniCart();
        slate.cart.openMiniCart();
        slate.cart.validateFreeGift();
        slate.cart.validatePromotionalGift();
      })
    }
  },

  addToCart: function(event) {
    event.preventDefault();
    var productDataArray = $('[data-product-form]').serializeArray()
    var variant = productDataArray.find(element => element.name === "id")
    var quantity = productDataArray.find(element => element.name === "quantity")

    var properties = {};

    productDataArray.forEach((data) => {
      if(data.name.indexOf('properties') != -1) {
        var name = data.name.replace('properties[','').replace(']', '');
        properties[name] = data.value;
      }
    })

    if (slate.cart.updatingCart == false) {
      slate.cart.updatingCart = true;
      CartJS.addItem(variant.value, parseInt(quantity.value), properties, {
        "success": function(data, textStatus, jqXHR) {
            slate.cart.updateCart()
            slate.cart.updateMiniCart()
            slate.cart.updateCartCount();
            slate.cart.openMiniCart();
            slate.cart.validateFreeGift();
            slate.cart.validatePromotionalGift();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            slate.cart.updatingCart = false;
            console.error("Add Item Error")
        }
      })
    }
  },

  addToMiniCart: function(event) {
      var activeYamlProduct = $(event.target).closest('.line-item')
      var productId = activeYamlProduct.find('[data-mini-cart-product-select]').val()
      if(slate.cart.updatingCart == false) {
        slate.cart.addProductFromId(productId)
      }
  },

  updateLineItem: function(itemIndex, itemQuantity, itemProperties = {}) {
    if (slate.cart.updatingCart == false) {
      slate.cart.updatingCart = true;
      CartJS.updateItem(itemIndex, itemQuantity, itemProperties, {
        "success": function(data, textStatus, jqXHR) {
            slate.cart.updateCart()
            slate.cart.updateMiniCart()
            slate.cart.updateCartCount();
            if(window.location.pathname == '/cart') {
              slate.cart.validateFreeGift(data);
              slate.cart.validatePromotionalGift(data);
            }
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.error("Line Item Update Error")
            slate.cart.updatingCart = false;
        }
      });
    }
  },

  removeLineItem: function(itemIndex) {
    if (slate.cart.updatingCart == false) {
      slate.cart.updatingCart = true;
      CartJS.removeItem(itemIndex, {
        "success": function(data, textStatus, jqXHR) {
            slate.cart.updateCart()
            slate.cart.updateMiniCart()
            slate.cart.updateCartCount();
            slate.cart.validateFreeGift(data);
            slate.cart.validatePromotionalGift(data);

        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.error("Line Item Remove Error")
            slate.cart.updatingCart = false;
        }
      });
    }
  },

  removeLineItemTrigger: function(event) {
    if(window.no_self_running_request) {
      window.no_self_running_request = false;
    }

    var $this = $(event.currentTarget);
    var $lineItemContainer =  $this.closest('[data-line-item]');
    var lineItemIndex = parseInt($lineItemContainer.attr('data-index'));
    if($this.data('monogramming-id') != null) {
      slate.cart.removeMonogrammingItems($this.data('monogramming-id'));
    } else {
      slate.cart.removeLineItem(lineItemIndex)
    }
  },

  quantityAdjust: function(event) {
    var item = $(event.currentTarget)
    var quantityInput = item.closest('[data-quantity]').find('[data-quantity-update]');
    var quantity = parseInt(quantityInput.val());

    if(item.attr('data-quantity-minus') != undefined){
      quantity = quantity - 1;
      if(quantity <= 0){
        quantity = 0;
      }
    }else{
      quantity = quantity + 1;
    }

    quantityInput.val(quantity).trigger('change')
  },

  quantityUpdate: function(event) {
    var lineItemIndex = parseInt($(event.currentTarget).closest('[data-line-item]').attr('data-index'));
    var lineItemQuantity = parseInt($(event.currentTarget).val())

    if(lineItemQuantity > 0){
      slate.cart.updateLineItem(lineItemIndex, lineItemQuantity);
    }else{
      slate.cart.removeLineItem(lineItemIndex);
    }
  },

  openMiniCart: function(e) {
    if(typeof e !== 'undefined') {
      e.preventDefault();
      if(window.location.href.indexOf('cart') === -1) {
        slate.cart.updateCart();
      } else {
        window.location.reload();
        return false;
      }
    }

    $('[data-mini-cart]').addClass('is-active');
    $('[data-mini-cart-overlay]').addClass('is-active');
    $('body').addClass('mini-cart-open');
  },

  closeMiniCart: function() {
    $('[data-mini-cart]').removeClass('is-active');
    $('[data-mini-cart-overlay]').removeClass('is-active');
    $('body').removeClass('mini-cart-open');
  },

  updateCartState: function(cart, count) {
      slate.cart.getCart()
      var cartCount = cart.item_count
      if(count){
          cartCount = count
      }
      if(cartCount > 0) {
        $('[data-cart-count]').html('<span><span aria-hidden style="font-size:0">Cart count</span>' + cartCount + '</span>').removeClass('visually-hidden');
      } else {
        $('[data-cart-count]').html('<span>0</span>').addClass('visually-hidden');
      }

  },

  updateMiniCart: function() {
    var options = { credentials: 'include' };
    return fetch('/cart?view=mini-cart', options)
    .then((res) => res.text())
    .then((data) => {
      $('#shopify-section-mini-cart .mini-cart').html($(data).find('.mini-cart').html());
      slate.cart.buildPromotionalGift();
      slate.cart.updatingCart = false;
      return Promise.resolve();
    });
  },

  getCart: function() {
    $.getJSON('/cart.json', function(data) {
        slate.cart.cartData = data;
        slate.cart.validateFreeGift();
        slate.cart.validatePromotionalGift();

        if($('.template-cart').length > 0 ) {
          slate.cart.initYmal();
          slate.cart.initSidebarSlider();
        };
    });
  },

  updateCart: function() {
    var options = { credentials: 'include' };
    return fetch('/cart?view=contents', options)
    .then((res) => res.text())
    .then((data) => {
      $('[data-cart]').html(data);
      slate.cart.buildPromotionalGift();
      slate.cart.initYmal();
      slate.cart.initSidebarSlider();
      slate.cart.updatingCart = false;
      return Promise.resolve();
    });
  },

  stickyButton: function() {
    if(window.location.href.indexOf("cart") > 1) {
      $(window).scroll(function() {
        var windowBottom = $(this).scrollTop() + $(this).innerHeight();
        var cartCheckoutButtonHeight = $("[data-cart-checkout-button]").offset().top + 100

        if(windowBottom >= cartCheckoutButtonHeight) {
          $("[data-cart-sticky-button]").fadeTo(1, 0)
          $("[data-cart-sticky-button]").removeClass('active')
          $("[data-cart-checkout-button]").fadeTo(0, 1)
        } else {
          $("[data-cart-sticky-button]").fadeTo(0, 1)
          $("[data-cart-sticky-button]").addClass('active')
          $("[data-cart-checkout-button]").fadeTo(1, 0)
        }
      }).scroll();
    }
  },

  initYmal: function() {
    var self = this;
    var cartData = [];
    if(slate.cart.cartData.items.length > 0) {
      slate.cart.cartData.items.forEach(function(el, index) {
        cartData.push(el.sku);
      })
    }

    var viewedProducts = Cookies.get('ss-viewed-products') || "";
    $.ajax(
      {
        url: 'https://do4xra.a.searchspring.io/boost/do4xra/recommend',
        data: JSON.stringify({
          'shopper': window.SHOPIFY_CUSTOMER_ID,
          'tags': ['view-cart'],
          'limit': 20,
          'cart': cartData,
          'lastViewed': viewedProducts.split(','),
        }),
        dataType: 'JSON',
        contentType: 'application/json',
        method: 'POST',
      }
    )
      .done(function(response) {
        if(response[0].results.length == 0) {
           $('.cart-ymal').hide()
        }

        self.ssRenderTrack.call(self, response);
        response[0].results.map(function(item) {
          item.stringMappings = JSON.stringify(item.mappings);
          if (item.mappings.core.msrp != 0) {
            item.mappings.core.msrp = slate.Currency.formatMoney(item.mappings.core.msrp * 100, window.theme.moneyFormat);
          } else {
            item.mappings.core.msrp == '';
          }

          if(item.attributes.tags) {
            for(i = 0; i < item.attributes.tags.length; i++) {
              if(item.badge !== "") {
                break;
              }

              if(item.attributes.tags[i].indexOf('badge:')) {
                var badge_parts = item.attributes.tags[i].split('badge:');
                item.badge = badge_parts[1];
              }
            }
          }

          if(item.ss_available === "0" && item.attributes.tags.length && item.attributes.tags.indexOf('bis-hidden') == -1) {
            item.badge = window.theme.strings.bisBadge;
            item.badge_type = "product-card__badge--back-in-stock";
          } else if(item.ss_available === "0"){
            item.badge = window.theme.strings.oosBadge;
          } else if(item.attributes.tags.length && item.attributes.tags.indexOf('preorder') != -1) {
            item.badge = 'Pre-order';
            item.badge_type = 'product-card__badge--preorder';
          } else if (item.mappings.core.msrp != 0) {
            item.badge = 'Sale'
          }


          item.mappings.core.price = slate.Currency.formatMoney(item.mappings.core.price * 100, window.theme.moneyFormat);
          item.mappings.core.imageUrl = item.attributes.ss_image || item.mappings.core.imageUrl;
          item.mappings.core.imageUrl = item.mappings.core.imageUrl.replace('600x600', '300x300');
          return item;
        });
        var ymalTemplateContent = $('[data-ymal-template]').html();
        if(typeof ymalTemplateContent === 'undefined') {
          return false;
        }
        var dataYmal = $('.cart [data-ymal]')
        var ymalTemplate =  Handlebars.compile($('[data-ymal-template]').html())
        var ymalData = ymalTemplate(response[0])
        dataYmal.html(ymalData)
        slate.cart.initYmalSlider()
      })
      .fail(function(xhr, response) {
         console.error(response)
      })
  },

  initYmalSlider: function() {
      var dataYmal = $('.cart [data-ymal]');
      var nextArrow = $('[data-arrow-next]');
      var prevArrow = $('[data-arrow-prev]');
      var slickOptions = {
        slidesToShow: 5.5,
        slidesToScroll: 5,
        infinite: false,
        dots: true,
        prevArrow,
        nextArrow,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 2,
            }
          }
        ]
      }

      if(dataYmal.is('.slick-initialized')) {
        dataYmal.slick('unslick');
      }

      dataYmal.slick(slickOptions);
  },

  initSidebarSlider: function() {
    var dataSidebarSlider = $('[data-cart-sidebar-slider]');
    var nextArrow = $('[data-cart-sidebar] [data-cart-sidebar-arrow-next]');
    var prevArrow = $('[data-cart-sidebar] [data-cart-sidebar-arrow-prev]');
    var slickOptions = {
      slidesToShow: 2.2,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      arrows: true,
      prevArrow,
      nextArrow,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 2,
          }
        }
      ]
    }

    dataSidebarSlider.slick(slickOptions);
  },

  validateFreeGift: function(cart) {
    var hasGiftProduct = false;
    var giftProductIndex;
    var giftProductId;
    var cartData = slate.cart.cartData;
    var giftQuantity = 0;

    if (cart) {
      cartData = cart;
    }

    cartData.items.forEach(function(item, index) {
      if (item.properties !== null && item.properties.hasOwnProperty('__freeGift'))  {
        hasGiftProduct = true;
        giftProductId = item.product_id;
        giftProductIndex = index+1;
        giftQuantity = item.quantity;
        return;
      }
    });

    if (typeof theme.freeGift === 'undefined') {
      if(hasGiftProduct) {
        CartJS.removeItem(giftProductIndex, {
          "success": function(data) {
            slate.cart.updateCart();
            slate.cart.updateMiniCart();
            slate.cart.updateCartCount();
          }
        })
      }
      return;
    } else if(hasGiftProduct && theme.freeGift.productId !== giftProductId) {
      CartJS.removeItem(giftProductIndex, {
        "success": function(data) {
          slate.cart.updateCart();
          slate.cart.updateMiniCart();
          slate.cart.updateCartCount();
        }
      })
      return;
    }

    if(cartData.total_price >= theme.freeGift.threshold && !hasGiftProduct ) {
      if (typeof theme.freeGift.addToCartVariant !== 'undefined') {
        CartJS.addItem(theme.freeGift.addToCartVariant, 1, {
            "__freeGift": "true",
        },{
          "success": function(data, textStatus, jqXHR) {
            slate.cart.updateCart();
            slate.cart.updateMiniCart();
            slate.cart.updateCartCount();
          }
        })
      }
    } else if(cartData.total_price < theme.freeGift.threshold && hasGiftProduct) {
      $.post('/cart/change.js', { quantity: 0, line: giftProductIndex }).done( function(data) {
        var cartCount = cartData.item_count - 1;
        this.cartData = data;
        slate.cart.updateCart();
        slate.cart.updateMiniCart();
        slate.cart.updateCartState(data, cartCount);
      })
    }

    if(cartData.total_price >= theme.freeGift.threshold && giftQuantity > 1) {
      var removeQuantity = giftQuantity - 1;
      CartJS.updateItem(giftProductIndex, 1, {
        "__freeGift":"true"
      },{
        "success":function(data) {
          var cartCount = cartData.item_count - removeQuantity;
          slate.cart.updateCart();
          slate.cart.updateMiniCart();
          slate.cart.updateCartCount();
        }
      })
    }
  },

  validatePromotionalGift(cart) {
    const promotionalGift = JSON.parse(sessionStorage.getItem('promotionalGift'));
    var hasGiftProduct = false;
    var giftProductId;
    var giftProductIndex;
    var cartData = slate.cart.cartData;
    var giftQuantity = 0;

    if (cart) {
      cartData = cart;
    }

    cartData.items.forEach(function(item, index) {
      if (item.properties !== null && item.properties.hasOwnProperty('__promotionalGift'))  {
        hasGiftProduct = true;
        giftProductId = item.product_id;
        giftProductIndex = index+1;
        giftQuantity = item.quantity;
        return;
      }
    });

    if(hasGiftProduct) {
      if (!promotionalGift || (cartData.items.length == 1 && cartData.items[0].product.id == giftProductId) || promotionalGift.id != giftProductId) {
        CartJS.removeItem(giftProductIndex, {
          "success": function(data) {
            slate.cart.updateCart();
            slate.cart.updateMiniCart();
            slate.cart.updateCartCount();
          }
        })
        return;
      }
      if (giftQuantity > 1) {
        var removeQuantity = giftQuantity - 1;
        CartJS.updateItem(giftProductIndex, 1, {
          "__promotionalGift":"true"
        },{
          "success":function(data) {
            var cartCount = cartData.item_count - removeQuantity;
            slate.cart.updateCart();
            slate.cart.updateMiniCart();
            slate.cart.updateCartCount();
          }
        })
      }
    } else {
      if (cartData.items.length > 0 && promotionalGift && promotionalGift.variants.length == 1) {
        CartJS.addItem(promotionalGift.variants[0].id, 1, {
          "__promotionalGift": "true",
        },{
          "success": function(data, textStatus, jqXHR) {
            slate.cart.updateCart();
            slate.cart.updateMiniCart();
            slate.cart.updateCartCount();
          }
        })
      }
    }
  },

  addFreeGiftToCart: function(evt) {
    var freeGiftProductId = $('[data-free-gift-variant]:checked').val();
    if (slate.cart.updatingCart == false) {
      var hasFreeGift = false;
      slate.cart.updatingCart = true;
      // Validate the cart before submitting the new item
      var updatedCart = {}

      $.getJSON('/cart.json', function(response) {
        updatedCart = response;
        response.items.forEach(function(product) {
          if(product.properties['__freeGift'] != null) {
            hasFreeGift = true;
          }
        });
      }).then(function() {
        if (hasFreeGift) {
          slate.cart.updateCart();
          slate.cart.updateMiniCart();
          slate.cart.updateCartState(updatedCart);
        } else {
          CartJS.addItem(freeGiftProductId, 1, {
            "__freeGift": "true"
          }, {
            "success": function(data) {
              var cartCount = slate.cart.cartData.item_count + 1;
              slate.cart.updateCart();
              slate.cart.updateMiniCart();
              slate.cart.updateCartState(data, cartCount);
            }
          })
        }
      })
    }
  },

  addPromotionalGiftToCart: function(evt) {
    var promotionalGiftProductId = $('[data-promotional-gift-variant]:checked').val();
    if (slate.cart.updatingCart == false) {
      slate.cart.updatingCart = true;

      CartJS.addItem(promotionalGiftProductId, 1, {
        "__promotionalGift": "true"
      }, {
        "success": function(data) {
          var cartCount = slate.cart.cartData.item_count + 1;
          slate.cart.updateCart();
          slate.cart.updateMiniCart();
          slate.cart.updateCartState(data, cartCount);
        }
      })
    }
  },

  checkFreeGiftSelected: function(evt) {
    var $optionsContainer = $('.line-item__free-gift-options-container');

    if($optionsContainer.length > 0) {
      if($optionsContainer.hasClass('has-error')) {
        evt.preventDefault()
        return
      } else {
        evt.preventDefault()
        $optionsContainer.addClass('has-error');
        $('html, body, [data-mini-cart-items]').animate({
          scrollTop: 0
        }, 500);
      }
    }
  },

  removeMonogrammingItems (monogrammingId) {

    // Todo: review the response and find the item with the same id to remove it from th cart after the first call is done, then update everything
    var cartItems = [];
    slate.cart.cartData.items.forEach(element => {
      if(element.properties == null ||
         parseInt(element.properties["_pc_pricing_ref"]) !== monogrammingId) {
        cartItems.unshift({
          id: element.id,
          quantity: element.quantity,
          properties: element.properties || {},
        })
      }
    });
    $.ajax('/cart/clear.js').done(() => {
      if(cartItems.length) {
        $.post('/cart/add.js', {
          items: cartItems
        }).done((data) => {
          slate.cart.updateCartCount();
          slate.cart.updateCart();
          slate.cart.updateMiniCart();
          slate.cart.validateFreeGift();
          slate.cart.validatePromotionalGift();
        });
      } else {
        slate.cart.updateCartCount();
        slate.cart.updateCart();
        slate.cart.updateMiniCart();
      }
    })
  },
  updateCartCount () {
    $.get('/cart.js').then((data) => {
      const cart = JSON.parse(data);
      slate.cart.updateCartState(cart, cart.item_count);
    })
  },
  ssRenderTrack: function(response) {
    var commonId = uuidv4();
    var seed = [];

    slate.cart.cartData.items.forEach(function(item) {
      seed.push({ 'sku': item.sku });
    });


    var beaconData = [{
      "type": "profile.render",
      "category": "searchspring.recommendations.user-interactions",
      "id": commonId,
      "pid": null,
      "event": {
        "profile": {
          "tag": "view-cart",
          "placement": "basket-page",
          "seed": seed
        },
        "context": {
          "type": "product-recommendation",
          "tag": "view-cart",
          "placement": "basket-page"
        },
      },
      "context": {
        "website": {"trackingCode": "do4xra"},
        "userId": Cookies.get('ssUserId'),
        "sessionId": Cookies.get('ssSessionIdNamespace'),
        "pageLoadId": Cookies.get('ssPageloadId')
      }
    }];

    response[0].results.forEach(function(item) {
      var productRenderData = {
        "type": "profile.product.render",
        "category": "searchspring.recommendations.user-interactions",
        "id": uuidv4(),
        "pid": commonId,
        "event": {
          "product": {
            "id": item.id,
            "seed": seed,
            "mappings": item.mappings
          },
          "context": {
            "type": "product-recommendation",
            "tag": "product-page",
            "placement": "basket-page"
          }
        },
        "context": {
          "website": {"trackingCode": "do4xra"},
          "userId": Cookies.get('ssUserId'),
          "sessionId": Cookies.get('ssSessionIdNamespace'),
          "pageLoadId": Cookies.get('ssPageloadId')
        }
      }

      beaconData.push(productRenderData);
    });

    beaconData.forEach(function(item) {
      if(item.type == 'profile.render') {
        var newType = 'profile.impression'
      } else if (item.type == 'profile.product.render') {
        var newType = 'profile.product.impression';
      }
      var impressionData = Object.assign({}, item, {
        type: newType,
        id: uuidv4(),
        pid: commonId
      })

      beaconData.push(impressionData);
    });

    $.ajax({
      url: 'https://beacon.searchspring.io/beacon',
      dataType: 'JSON',
      data: JSON.stringify(beaconData),
      contentType: 'application/json',
      method: 'POST',
    });
  },
  ssClickTrack: function(evt) {
    var $target = $(evt.target);
    var $card = $target.closest('[data-ss-product]');
    var commonId = uuidv4();
    var seed = [];

    slate.cart.cartData.items.forEach(function(item) {
      seed.push({ 'sku': item.sku });
    });
    var beaconData = [{
      "type": "profile.click",
      "category": "searchspring.recommendations.user-interactions",
      "id": commonId,
      "pid": null,
      "event": {
        "profile": {
          "tag": "view-cart",
          "placement": "basket-page",
          "seed": seed
        },
        "context": {
          "type": "product-recommendation",
          "tag": "view-cart",
          "placement": "basket-page"
        },
      },
      "context": {
        "website": {"trackingCode": "do4xra"},
        "userId": Cookies.get('ssUserId'),
        "sessionId": Cookies.get('ssSessionIdNamespace'),
        "pageLoadId": Cookies.get('ssPageloadId')
      }
    }];
    if($card.length > 0) {
      var productId = $card.data('product-id');
      var mappings = $card.data('product-data');
      var productClick = {
        "type": "profile.product.click",
        "category": "searchspring.recommendations.user-interactions",
        "id": uuidv4(),
        "pid": commonId,
        "event": {
          "product": {
            "id": productId,
            "seed": seed,
            "mappings": mappings
          },
          "context": {
            "type": "product-recommendation",
            "tag": "product-page",
            "placement": "basket-page"
          }
        },
        "context": {
          "website": {"trackingCode": "do4xra"},
          "userId": Cookies.get('ssUserId'),
          "sessionId": Cookies.get('ssSessionIdNamespace'),
          "pageLoadId": Cookies.get('ssPageloadId')
        }
      }

      beaconData.push(productClick);
    }

    ga('send', 'event', 'personalized-recommendations', 'recommendations-click', 'also-viewed');
    $.ajax({
      url: 'https://beacon.searchspring.io/beacon',
      dataType: 'JSON',
      data: JSON.stringify(beaconData),
      contentType: 'application/json',
      method: 'POST',
    });
  },
  customizerAddToCart(e) {
    slate.cart.updateMiniCart();
    pplr_w_h();
    slate.cart.openMiniCart();
    slate.cart.updateCartCount();
  },
  buildPromotionalGift() {
    const promotionalGift = JSON.parse(sessionStorage.getItem('promotionalGift'));
    const promotionalGiftPrompt = document.querySelector(`[data-mini-cart-items] [data-promotional-gift]`);
    const promotionalGiftPromptCart = document.querySelector(`[data-cart-body] [data-promotional-gift]`);

    if (promotionalGift && promotionalGift.variants.length > 1) {
      let promotionalGiftHtml = `
        <div class="line-item__image">
          <a href="${promotionalGift.url}">
            <img
              src="${promotionalGift.thumbnail_image}"
                class=""
                alt="${promotionalGift.title}">
          </a>
        </div>
        <div class="line-item__content ${promotionalGiftPromptCart ? '':'line-item__content--mini-cart'}">
          <div class="line-item__free-gift-header">
            ${theme.strings.giftMessage}
          </div>
          <div class="line-item__free-gift-title-container">
            <h6 class="line-item__title">
              ${promotionalGift.title}
            </h6>
            <div class="${promotionalGiftPromptCart ? 'line-item__total-price':'line-item__price'}">
              FREE
            </div>
          </div>`;

      if (promotionalGiftPromptCart) {
        promotionalGiftHtml += `
          <div class="line-item__free-gift-options-container line-item__free-gift-options-container--desktop">
            <div class="line-item__free-gift-options-header">
              Choose an option:
            </div>
            <div class="line-item__free-gift-options-group">`;

        promotionalGift.variants.map(variant => {
          promotionalGiftHtml += `
              <label class="option-item ${variant.available ? '':'option-item--disabled'}">
                <input type="radio" style="display: none;" name="id" value="${variant.id}" data-promotional-gift-variant ${variant.available ? '':'disabled'}>
                <div class="option-item__ui">
                  ${variant.title}
                </div>
              </label>`;
        });

        promotionalGiftHtml+= `
            </div>
            <span class="line-item__free-gift-selection-error">
              ${theme.icons.iconAlertCircle}
              <span>
                Please make a selection above before proceeding to checkout.
              </span>
            </span>
          </div>`;
      }

      promotionalGiftHtml += `
        </div>
        <div class="line-item__free-gift-options-container ${promotionalGiftPromptCart ? 'line-item__free-gift-options-container--mobile':''}">
          <div class="line-item__free-gift-options-header">
            Choose an option:
          </div>
          <div class="line-item__free-gift-options-group">`;

      promotionalGift.variants.map(variant => {
        promotionalGiftHtml += `
            <label class="option-item ${variant.available ? '':'option-item--disabled'}">
              <input type="radio" style="display: none;" name="id" value="${variant.id}" data-promotional-gift-variant ${variant.available ? '':'disabled'}>
              <div class="option-item__ui">
                ${variant.title}
              </div>
            </label>`;
      });

      promotionalGiftHtml += `
          </div>
          <span class="line-item__free-gift-selection-error">
            ${theme.icons.iconAlertCircle}
            <span>
              Please make a selection above before proceeding to checkout.
            </span>
          </span>
        </div>
      `;

      promotionalGiftPrompt && (promotionalGiftPrompt.innerHTML = promotionalGiftHtml);
      promotionalGiftPrompt && (promotionalGiftPrompt.classList.add('active'));
      promotionalGiftPromptCart && (promotionalGiftPromptCart.innerHTML = promotionalGiftHtml);
      promotionalGiftPromptCart && (promotionalGiftPromptCart.classList.add('active'));
    }
  }
};
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },
  validateForm: function(e) {
    var $form = $(e.currentTarget);
    var $formFields = $('input', $form);
    var invalidCount = 0;

    $formFields.each(function(index, field) {
      var $field = $(field);
      if ($field.hasClass('has-error')) {
        invalidCount++;
      }
    })

    if(invalidCount > 0) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  validateField: function(e) {
    var $field = $(e.currentTarget);
    if(!$field.get(0).checkValidity()) {
      $field.addClass('has-error');
      if($field.siblings('.form-group__info').length === 0) {
        $field.after('<small class="form-group__info">'+ $field.get(0).validationMessage +'</small>');
      } else {
        $field.siblings('.form-group__info').text($field.validationMessage);
      }
    }
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

slate.utils.ajaxKlaviyoForm = (function () {
  function ajaxKlaviyoForm(form, options) {
    this.name = 'ajaxKlaviyoForm',
    this.namespace = '.' + this.name;

    // set defaults
    var defaults = {
      source: 'Shopify Form',
      onInit: $.noop,
      onSubmitFail: $.noop,
      onBeforeSend: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop,
    }

    if(form.length === 0) {
      return false;
    }

    this.$form = form instanceof $ ? form : $(form);
    this.$input = $('input[type=email]', this.$form);
    this.$phoneField = $('input[type=tel]', this.$form);
    this.$submit = $('input[type=submit]', this.$form);
    this.settings = $.extend('', defaults, options);

    if (typeof this.settings.listId == 'undefined'){
      console.warn('['+this.namespace+'] A valid list Id is required for this module to work')
    }

    this.$form.on('submit', this.onFormSubmit.bind(this));
    this.settings.onInit();
  }

  ajaxKlaviyoForm.prototype = $.extend({}, ajaxKlaviyoForm.prototype, {
    _logErrors: function(errors) {
      if(Array.isArray(errors) && errors.length){
        for (let i = 0; i < errors.length; i++) {
          console.warn('['+this.name+'] - Submit fail: ' + errors[i]);
        }
      }
    },

    onBeforeSend: function() {
      if(this.settings.onBeforeSend === false) {
        return false;
      } else {
        this.settings.onBeforeSend();
      }

      this.$submit.prop('disabled', true);

    },

    onSubmitDone: function(response) {
      this.$submit.prop('disabled', false);
      if(this.settings.onSubscribeSuccess === false) {
        console.log(response);
      } else {
        this.settings.onSubscribeSuccess(response);
      }
    },

    onSubmitFail: function(errors) {
      this.$submit.prop('diabled', false);
      this._logErrors(errors);
      this.settings.onSubmitFail(errors);
    },

    onFormSubmit: function(e) {
      e.preventDefault();
      var self = this;

      const body = {
        "data": {
          "type": "subscription",
          "attributes": {
            "custom_source": this.settings.source,
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "properties": {
                  }
                },
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": this.settings.listId
              }
            }
          }
        }
      }

      if(this.$phoneField.val() != '') {
        const phoneNumber = '+1' + this.$phoneField.val().replaceAll(/[^0-9]+/g, '');
        body.data.attributes.profile.data.attributes.phone_number = phoneNumber;
      }

      if(this.$input.val() != '') {
        body.data.attributes.profile.data.attributes.email = this.$input.val();
      }

      if(this.settings.birthdayField && this.settings.birthdayField.val() != '') {
        body.data.attributes.profile.data.attributes.properties.$birthday = this.settings.birthdayField.val();
      }

      $.ajax({
        async: true,
        crossDomain: true,
        url: 'https://a.klaviyo.com/client/subscriptions/?company_id=PaitnH',
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          revision: '2024-02-15'
        },
        data: JSON.stringify(body),
        beforeSend: this.onBeforeSend.bind(this),
      })
      .done(function(response){
        self.onSubmitDone(response);
      })
      .fail(function(jqXHR){
        var errors = [];

        if(jqXHR && jqXHR?.responseJSON && jqXHR.responseJSON?.errors){
          errors = jqXHR.responseJSON.errors;
        }

        self.onSubmitFail(errors);
      })
    }
  })

  return ajaxKlaviyoForm;
})(jQuery)
slate.LoadMore = (function($) {

  selectors = {
    loadMoreButton: "[data-load-more-button]",
    gridContainer: "[data-grid-container]"
  }

  function LoadMore(container) {
    this.$container = $(container);
    this.name = 'loadMore';
    this.namespace = '.' + this.name;
    this.isLoading = false;
    this.requestList = [];

    this.$window = $(window);
    this.$document = $(document);
    this.$loadMoreButton = $(selectors.loadMoreButton, this.$container);
    this.$gridContainer = $(selectors.gridContainer, this.$container);

    this.$loadMoreButton.on('click', this.loadNextPage.bind(this));
    this.buttonText = this.$loadMoreButton.text();
    this.scrollThreshold = this.$gridContainer.data('page-scroll') / 100;

    // this.checkCurrentPage.call(this);

    this.$window.on('scroll', $.throttle(20, this.checkScroll.bind(this)));
  };

  LoadMore.prototype = $.extend({}, LoadMore.prototype, {
    checkCurrentPage: function() {
      var searchParams = new URL(document.location).searchParams;
      var currentPage = searchParams.get('page');

      if(currentPage) {
        this.fetchPreviousPages.call(this, currentPage);
      }
    },
    fetchPreviousPages: function(currentPage) {
      var newUrl = new URL(document.location);

      for(var i = 1; i < currentPage;  i++) {
        newUrl.searchParams.set("page", i);
        this.requestList.push(newUrl.href);
      };

      this.processRequestList.call(this);
    },
    processRequestList() {
      var self = this;
      $.ajax(this.requestList[this.requestList.length - 1], {
        method: "GET",
        contentType: "HTML",
      }).then(function(response) {
        var $newPage = $(response);
        var $newCards = $newPage.find(selectors.gridContainer).children();
        self.$gridContainer.prepend($newCards)

        self.requestList.pop();
        if(self.requestList.length > 0) {
          self.processRequestList();
        }
      })
    },
    loadNextPage: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if(this.isLoading) {
        return;
      }

      var self = this;

      var nextPage = this.$loadMoreButton.data('next-page');

      this.isLoading = true;
      this.$loadMoreButton.text('Loading...');

      $.ajax(nextPage, {
        method: "GET",
        contentType: "HTML"
      }).then(function(response) {
        var  $newPage = $(response);
        var productCards = $newPage.find(selectors.gridContainer).children();
        self.$gridContainer.append(productCards);
        self.updateUrl.call(self);
        self.updateLoadMoreButton.call(self, $newPage);
        self.updateYotpoSnippets.call(self);
        self.isLoading = false;
        var event = $.Event('pageUpdated');
        $(window).trigger(event);
      })
    },
    updateUrl: function() {
      window.history.replaceState('', document.title,  this.$loadMoreButton.data('next-page'));
    },
    updateLoadMoreButton: function($newContent) {
      var $newLoadMoreButton = $newContent.find(selectors.loadMoreButton);
      if($newLoadMoreButton.length) {
        this.$loadMoreButton.data('next-page', $newLoadMoreButton.data('next-page'));
        this.$loadMoreButton.attr('href', $newLoadMoreButton.attr('next-page'));
        this.$loadMoreButton.text(this.buttonText);
      } else {
        this.$loadMoreButton.remove();
      }
    },
    checkScroll: function() {
      var documentHeight = document.body.scrollHeight;
      var scrollThreshold = documentHeight * this.scrollThreshold;
      if(!this.isLoading && this.$window.scrollTop() > scrollThreshold){
        this.$loadMoreButton.trigger('click');
      }
    },
    updateYotpoSnippets() {
      if(typeof yotpoWidgetsContainer !== 'undefined'){
        setTimeout(() => {
          yotpoWidgetsContainer.initWidgets();
        }, 100);
      }
    }
  });

  return LoadMore;
})($)

/*================ Sections ================*/
/**
 * Header section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 *
 * @namespace header
 */
theme.Header = (function () {
  var selectors = {
    topBar: '.top-bar',
    header: '[data-header]',
    mobileToggle: '[data-mobile-toggle]',
    closeIcon: '[data-close-icon]',
    openIcon: '[data-open-icon]',
    menuToggleBtn: '[data-toggle-btn]',
    menuToggleContent: '[data-toggle-content]',
    desktopNavItem: '[data-desktop-nav-item]',
    searchForm: '[data-search-form]',
    searchInput: '[data-search-input]',
    searchClear: '[data-search-clear]',
    autocompleteTemplate: '[data-autocomplete-template]',
    autocompleteContainer: '[data-autocomplete-container]',
    headerFiller: '[data-header-filler]',
    desktopNav: '.desktop-nav',
  };

  var classes = {
    submenuOpen: 'is-open',
    searchActive: 'search-active',
    stickyHeader: 'header-sticky',
  };

  var HEADER_BREAKPOINT = 980;
  this.mobileMenuOpen = false;

  function Header(container) {
    this.name = 'header';
    this.namespace = '.' + this.name;
    this.$container = $(container);
    var self = this;
    // cache DOM
    this.$window = $(window);
    this.$body = $('body');
    this.$html = $('html');
    this.$desktopNavItems = $(selectors.desktopNavItem);

    this.$header = $(selectors.header, this.$container);
    this.$mobileToggle = $(selectors.mobileToggle, this.$container);
    this.$closeIcon = $(selectors.closeIcon, this.$container);
    this.$openIcon = $(selectors.openIcon, this.$container);
    this.$mobileAccordions = $(selectors.mobileAccordion, this.$container);
    this.$searchForm = $(selectors.searchForm);
    this.$searchInput = $(selectors.searchInput);
    this.$searchClear = $(selectors.searchClear);
    this.$autocompleteContainer = $(selectors.autocompleteContainer);
    this.$headerFiller = $(selectors.headerFiller, this.$container);
    this.$desktopNavContainer = $(selectors.desktopNav);
    // Compiles Handlebars template to inject the data.
    this.autocompleteTemplate = Handlebars.compile($(selectors.autocompleteTemplate).html());

    this.tabletMode = false;
    this.autocompleteActive = false;

    this.initAnnouncementSlider();
    this.checkAndEnableTabletMode();
    this.stickHeader();

    /***
     * Listeners
     */
    // init accordions - only one accordion will be open at a time
    $(selectors.menuToggleBtn).on('click', function (e) {
      e.preventDefault();
      // close toggle if it's already open
      if ($(this).hasClass('is-open')) {
        $(this).next(selectors.menuToggleContent).slideUp();
        $(this).removeClass(classes.submenuOpen);
        return;
      }
      // close all menus
      $(selectors.menuToggleBtn).each(function (i, el) {
        $(el).removeClass(classes.submenuOpen);
        $(el).next(selectors.menuToggleContent).slideUp();
      });

      // open clicked element
      $(this).next(selectors.menuToggleContent).slideToggle();
      $(this).toggleClass(classes.submenuOpen);
    });
    // close an opened mobile menu when window is sized up
    this.$window.on('resize', $.debounce(50, this.resizeActions.bind(this)));
    // Updates the sticky state of the header
    this.$window.on('scroll', $.throttle(20, this.stickHeader.bind(this)));

    // handle mobile toggle
    $(selectors.mobileToggle).on('click', this.toggleMobileMenu.bind(this));
    // close mobile menu when clicking outside menu
    document.addEventListener('click', function (e) {
      if (e.target.matches('.mobile-menu-open')) {
        self.toggleMobileMenu();
      }
    });
    this.$searchForm.on('submit', this.checkFormStatus.bind(this));

    // tablet menu click listener
    this.$desktopNavItems.on('click', this.handleDesktopNavItemClick.bind(this));
    this.$desktopNavItems.on('mouseenter', this.handleDesktopNavItemMouseEnter.bind(this));
    this.$desktopNavItems.on('mouseleave', this.handleDesktopNavItemMouseLeave.bind(this));
    // Searchspring integration
    this.buildUUID();
    this.$searchInput.on('keyup', $.debounce(100, this.searchAutocomplete.bind(this)));
    this.$searchInput.on('focus', this.searchAutocomplete.bind(this));
    this.$searchInput.on('click', this.onInputClick.bind(this));
    this.$searchClear.on('click', this.searchClear.bind(this));
    this.$window.on('click', this.closeAutocomplete.bind(this));
    this.$autocompleteContainer.on('click', 'a', this.ssTrackClick.bind(this));
  }

  Header.prototype = $.extend({}, Header.prototype, {
    stickHeader: function () {
      if (this.$window.outerWidth() >= 980) {
        this.$headerFiller.height(0);
        // this.$body.removeClass(classes.stickyHeader);
        return;
      }

      var topBarHeight = $(selectors.topBar).outerHeight();
      var headerHeight = this.$header.outerHeight();
      var windowHeight = this.$window.outerHeight();
      var fillerHeight = headerHeight;

      if (this.$window.scrollTop() >= topBarHeight) {
        this.$body.addClass(classes.stickyHeader);
        this.$headerFiller.height(fillerHeight);
        $('.mobile-nav__inner').css({
          top: fillerHeight,
          height: windowHeight - fillerHeight,
        });
      } else {
        this.$body.removeClass(classes.stickyHeader);
        this.$headerFiller.height(0);
        $('.mobile-nav__inner').removeAttr('style');
      }
    },

    buildUUID: function () {
      if (typeof Cookies.get('ssSessionIdNamespace') == 'undefined') {
        Cookies.set('ssSessionIdNamespace', uuidv4());
      }

      if (typeof Cookies.get('ssUserId') == 'undefined') {
        Cookies.set('ssUserId', uuidv4());
      }

      Cookies.set('ssPageloadId', uuidv4());
      var userId = window.SHOPIFY_CUSTOMER_ID || Cookies.get('ssUserId');
      Cookies.set('_isuid', userId);
    },

    searchAutocomplete: function (e) {
      // handles the search while the user is writing on the search field
      var $this = $(e.currentTarget);
      var searchParam = $this.val();
      var self = this;
      var customerId = window.SHOPIFY_CUSTOMER_ID || Cookies.get('ssUserId');

      if (typeof Cookies.get('ssSessionIdNamespace') == 'undefined') {
        this.buildUUID();
      }

      if (searchParam.length > 2) {
        $.ajax({
          url: 'https://do4xra.a.searchspring.io/api/suggest/query',
          method: 'GET',
          data: {
            query: searchParam,
            siteId: 'do4xra',
            suggestionCount: 6,
          },
        }).done(function (suggestion) {
          $.ajax({
            url: 'https://do4xra.a.searchspring.io/api/search/autocomplete.json',
            method: 'GET',
            headers: {
              'searchspring-session-id': Cookies.get('ssSessionIdNamespace'),
              'searchspring-user-id': customerId,
              'searchspring-page-load-id': Cookies.get('ssPageloadId'),
            },
            dataType: 'JSON',
            data: {
              q: suggestion.suggested ? suggestion.suggested.text : suggestion.query,
              'bgfilter.ss_is_published': 1,
              resultsFormat: 'native',
              resultsPerPage: 12,
              siteId: 'do4xra',
              userId: customerId,
              domain: window.location.href,
            },
          })
            .done(function (results) {
              results.search_url = '/search?q=' + (suggestion.suggested ? suggestion.suggested.text : suggestion.query);
              results.search_param = suggestion.suggested ? suggestion.suggested.text : suggestion.query;
              results.suggestions = suggestion.alternatives;
              self.buildAutocompleteTemplate.call(self, results);
            })
            .fail(function (xhr, error) {
              self.onSearchRequestError.call(self, error);
            });
        });
      } else {
        this.closeAutocomplete();
      }
    },

    ssTrackClick: function (evt) {
      var $this = $(evt.currentTarget);
      var intellisuggestData = $this.data('intellisuggest-data');
      var intellisuggestSignature = $this.data('intellisuggest-signature');
      var searchParam = $this.data('search-param');
      var category = $this.data('suggested-term');
      var productData = {
        price: $this.data('price'),
        searchPosition: $this.data('result-index'),
        brand: $this.data('brand'),
        productId: $this.data('product-id'),
        name: $this.data('product-name'),
      };
      if (typeof intellisuggestData != 'undefined' && typeof intellisuggestSignature != 'undefined') {
        window.intellisuggestTrackClick(evt.currentTarget, intellisuggestData, intellisuggestSignature);
      }

      if (typeof category !== 'undefined') {
        this.trackElevarEvent('dl_ss_kw_suggestion', category);
      } else {
        this.trackElevarEvent('dl_ss_prod_click', searchParam, productData);
      }
    },

    checkFormStatus: function (evt) {
      var searchValue = $(selectors.searchInput, evt.currentTarget).val();
      if (searchValue === '') {
        evt.preventDefault();
        evt.stopPropagation();
      }
    },

    searchClear: function () {
      this.$searchInput.val('').trigger('keyup');
    },

    closeAutocomplete: function (evt) {
      var performAction = false;
      if (this.autocompleteActive == true && typeof evt !== 'undefined') {
        var $this = $(evt.target);
        if ($this.parents(selectors.searchForm).length != 1) {
          performAction = true;
        }
      }

      if (performAction == true || typeof evt === 'undefined') {
        this.autocompleteActive = false;
        this.$autocompleteContainer.removeClass(classes.searchActive);
        this.$searchInput.removeClass(classes.searchActive);
      }
    },

    buildAutocompleteTemplate: function (response) {
      response.results.map(function (item) {
        if (item.msrp != 0) {
          item.msrp = slate.Currency.formatMoney(item.msrp * 100, window.theme.moneyFormat);
        } else {
          item.msrp = '';
        }
        item.imageUrl = item.ss_image || item.imageUrl;
        item.price = slate.Currency.formatMoney(item.price * 100, window.theme.moneyFormat);

        return item;
      });
      this.$autocompleteContainer.html(this.autocompleteTemplate(response));
      this.$autocompleteContainer.addClass(classes.searchActive);
      this.$searchInput.addClass(classes.searchActive);

      this.autocompleteActive = true;
    },

    onSearchRequestError: function (response) {
      console.error('[' + this.namespace + '] - Search autocomplete error. Message: ', response);
    },

    toggleMobileMenu: function () {
      this.$html.toggleClass('mobile-menu-open');
      this.$closeIcon.toggle();
      this.$openIcon.toggle();
      this.mobileMenuOpen = !this.mobileMenuOpen;
      this.searchClear();
    },

    closeDesktopNav: function () {
      this.$desktopNavItems.each(function (i, el) {
        $(el).removeClass(classes.submenuOpen);
      });
    },

    handleDesktopNavItemClick: function (e) {
      if (!this.tabletMode) return;
      // on tablets, prevent top-level link navigation and instead open the submenu via click toggle
      e.preventDefault();

      // open or close submenu
      var $listItem = $(e.target).closest('li');
      if ($listItem.hasClass(classes.submenuOpen)) {
        // close nav dropdown
        $listItem.removeClass(classes.submenuOpen);
      } else {
        // close all other dropdowns
        this.closeDesktopNav();
        // open nav dropdown
        $listItem.addClass(classes.submenuOpen);
      }
    },

    handleDesktopNavItemMouseEnter: function (e) {
      const menu = $(e.target).closest(selectors.desktopNavItem).find('.desktop-nav__submenu');
      const rect = menu[0].getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (rect.right > viewportWidth) {
        const overflowAmount = rect.right - viewportWidth;
        menu.css('left', -overflowAmount);
      }

      this.$html.addClass('desktop-menu-open');
    },

    handleDesktopNavItemMouseLeave: function (e) {
      this.$html.removeClass('desktop-menu-open');
    },

    resizeActions: function () {
      this.stickHeader();
      this.closeMobileMenuOnViewportShift();
      this.checkAndEnableTabletMode();
    },

    closeMobileMenuOnViewportShift: function () {
      if (window.innerWidth < HEADER_BREAKPOINT) return;

      if (this.mobileMenuOpen) {
        this.toggleMobileMenu();
      }
    },

    initAnnouncementSlider: function () {
      const topBar = $(selectors.topBar);
      if (!topBar.length) return;

      $(topBar).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
      });
    },

    checkAndEnableTabletMode: function () {
      // user agent detection
      var userAgent = navigator.userAgent.toLowerCase();
      var isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
      if (isTablet) {
        this.tabletMode = true;
        $(selectors.desktopNavItem).each(function (i, el) {
          $(el).addClass('tablet-view');
        });
      } else {
        $(selectors.desktopNavItem).each(function (i, el) {
          $(el).removeClass('tablet-view');
        });
        this.tabletMode = false;
      }
      this.closeDesktopNav();
    },
    trackElevarEvent(eventName, searched_keyword, productData) {
      if (eventName != null) {
        window.dataLayer = window.dataLayer || [];
        if (eventName == 'dl_ss_prod_click') {
          window.dataLayer.push({
            event: eventName,
            search_position: productData.searchPosition,
            brand: productData.brand,
            product_id: productData.productId,
            price: productData.price,
            product_name: productData.name,
            searched_keyword: searched_keyword,
            click_location: 'Quick Search Product',
          });
        } else {
          window.dataLayer.push({
            event: eventName,
            clicked_keyword: searched_keyword,
          });
        }
      }
    },
    onInputClick() {
      this.trackElevarEvent('dl_ss_search_click');
    },
  });

  return Header; // where does this get executed?
})();

/**
   * Footer section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
 *
   * @namespace footer
 */
theme.Footer = (function () {

  var selectors = {
    dropdownToggler: '[data-footer-dropdown-header]',
    dropdown: '[data-footer-dropdown]',
    newsletterForm: '[data-klaviyo-form]',
    phoneField: '[data-phone-field]',
    formMessage: '[data-form-message]',
    formBirthdayField: '[data-birthday-field]',
    seoBlockToggler: '[data-seo-block-toggler]',
    seoBlockTogglerText: '[data-seo-block-toggler-text]',
    seoBlock: '[data-seo-block-container]',
  };

  var classes = {
    hidden: 'mobile-hidden',
    open: 'mobile-open',
    seoOpen: 'is-open',
    formSuccess: 'subscription-form--success',
    formError: 'subscription-form--error'
  }

  function Footer(container) {
    this.name = "footer";
    this.namespace = '.' + this.name;
    this.$container = $(container);

    this.$subscriptionForm = $(selectors.newsletterForm, this.$container);
    this.$subscriptionFormMessage = $(selectors.formMessage, this.$subscriptionForm);

    this.klaviyoForm = new slate.utils.ajaxKlaviyoForm(this.$subscriptionForm, {
      listId: this.$subscriptionForm.data('list-id'),
      birthdayField: this.$subscriptionForm.find(selectors.formBirthdayField),
      source: 'Footer subscription form',
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this),
    })
    this.$phoneField = $(selectors.phoneField, this.$container);
    this.$dropdownToggler = $(selectors.dropdownToggler, this.$container);
    this.$dropdowns = $(selectors.dropdown, this.$container);
    this.$seoBlock = $(selectors.seoBlock, this.$container);
    this.$seoBlockToggler = $(selectors.seoBlockToggler, this.$container);
    this.$seoBlockTogglerText = $(selectors.seoBlockTogglerText, this.$container);

    this.$dropdownToggler.on('click', this.toggleDropdown.bind(this));
    this.$seoBlockToggler.on('click', this.toggleSeoBlock.bind(this));
    this.$phoneField.on('input', this.maskPhoneField.bind(this));
  }

  Footer.prototype = $.extend({}, Footer.prototype, {
    // Subscription form methods
    onSubscribeSuccess() {
      var successMessage = this.$subscriptionForm.data('success-message')
      this.$subscriptionFormMessage.text(successMessage);
      this.$subscriptionForm.addClass(classes.formSuccess);
    },
    onSubmitFail() {
      var errorMessage = this.$subscriptionForm.data('error-message')
      this.$subscriptionFormMessage.text(errorMessage);
      this.$subscriptionForm.addClass(classes.formError);

      setTimeout(function() {
        this.$subscriptionForm.removeClass(classes.formError);
      }, 8000)
    },
    // Footer accordion methods
    toggleDropdown(e) {
      var $this = $(e.currentTarget);
      var $target = $this.data('toggle');
      if(window.matchMedia('(max-width: 980px)').matches) {
        if($this.hasClass(classes.open)) {
          $this.removeClass(classes.open);
          $('[data-menu="'+$target+'"]').slideUp(300, function() {
            $(this).addClass(classes.hidden);
            $(this).removeAttr('style');
          })
        } else {
          this.$dropdownToggler.removeClass(classes.open);
          $this.addClass(classes.open);
          this.$dropdowns.slideUp(300, function() {
            $(this).addClass(classes.hidden);
            $(this).removeAttr('style');
          })

          $('[data-menu="'+$target+'"]').slideDown(300, function() {
            $(this).removeClass(classes.hidden);
            $(this).removeAttr('style');
          })
        }
      }
    },
    toggleSeoBlock() {
      if(this.$seoBlock.hasClass(classes.seoOpen)) {
        this.$seoBlockTogglerText.text('Read More');
      } else {
        this.$seoBlockTogglerText.text('Read Less');
      }
      this.$seoBlock.toggleClass(classes.seoOpen);
    },
    maskPhoneField(evt) {
      var phoneVal = $(evt.target).val().replace(/(\D+)/g, '').match(/(\d{0,3})(\d{0,7})/);

      if(phoneVal[1] !== '') {
        $(evt.target).val(!phoneVal[2] ? '(' + phoneVal[1] : '(' + phoneVal[1] + ') ' + phoneVal[2]);
      } else {
        $(evt.target).val('');
      }
    },
    onSectionLoad() {
    }
  });

  return Footer; // where does this get executed?
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function ($) {
  var selectors = {
    productIdSelector: '[name="id"]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    nextArrow: '[data-arrow-next]',
    originalSelectorId: '[data-product-select]',
    prevArrow: '[data-arrow-prev]',
    priceWrapper: '[data-price-wrapper]',
    productGallery: '[data-product-gallery]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    completeTheLook: '[data-complete-the-look]',
    shopMoreColors: '[data-shop-more-colors]',
    thumbnailGallery: '[data-thumbnail-gallery]',
    thumbnailVideo: '[data-thumbnail-video]',
    galleryVideo: '[data-gallery-video]',
    galleryVideoPlay: '[data-gallery-video-play]',
    galleryVideoUnmute: '[data-gallery-video-unmute]',
    galleryVideoMute: '[data-gallery-video-mute]',
    lowStockData: '[data-low-stock-message]',
    metafieldsData: '[data-metafields-json]',
    dropdownToggler: '[data-product-details-dropdown-header]',
    dropdown: '[data-product-details-dropdown]',
    backInStock: '[data-pdp-backinstock]',
    qtyAddToCartContainer: '[data-pdp-qty-atc]',
    qtyStepper: '[data-qty-stepper]',
    qtyInput: '[data-qty-input]',
    bisEmailSubmit: '[data-bis-email]',
    bisPhoneField: '[data-bis-phone-field]',
    bisPhoneSubmit: '[data-bis-phone]',
    installmentOptions: '[data-installment-options]',
    //gallery
    zoomOpen: '[data-zoom-open]',
    zoomClose: '[data-zoom-close]',
    zoomModal: '[data-zoom-modal]',
    zoomThumbnail: '[data-zoom-thumbnail]',
    zoomImage: '[data-zoom-image]',
    zoomModalGallery: '[data-zoom-gallery]',
    // Monogramming box
    monogrammingToggle: '[data-toggle-monogramming]',
    monogrammingBox: '[data-monogramming-container]',
    monogrammingModalToggle: '[data-monogramming-toggle-guide]',
    monogrammingModal: '[data-monogram-guide-modal]',
    monogrammingModalOverlay: '[data-monogram-modal-overlay]',
    monogrammingCheckbox: '[data-monogramming-checkbox]',
    monogrammingProduct: '[data-monogramming-product-json]',
    //Product ymal
    productYmal: '[data-product-ymal]',
    searchSrpingProduct: '[data-ss-product]',
    //Size guide auto modal
    sizeGuideButton: '[data-modal-template="size-guide"]',
    //Product badge
    badgeContainer: '[data-product-badges]',
  };

  var classes = {
    hidden: 'mobile-hidden',
    open: 'mobile-open',
    mobileVisible: 'mobile-visible',
    modalOpen: 'is-open',
    active: 'is-active',
    monogrammingOpen: 'monogramming-container--open',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    this.$badgeContainer = $(selectors.badgeContainer, this.$container);
    this.nextArrow = $(selectors.nextArrow, this.$container);
    this.prevArrow = $(selectors.prevArrow, this.$container);
    var self = this;

    // slick options for thumbnail gallery nav
    this.thumbnailSliderOptions = {
      asNavFor: $(selectors.productGallery),
      slidesToShow: 4,
      slidesToScroll: 1,
      focusOnSelect: true,
      dots: false,
      arrows: true,
      infinite: true,
      rows: 0,
      vertical: true,
      verticalSwiping: true,
      infinite: true,
      lazyload: 'progressive',
      prevArrow: '<button class="arrow-previous"><img src="https://cdn.shopify.com/s/files/1/1303/8939/files/pdp-thumb-up.svg?v=1617313066" alt="product image thumbnail up"></button>',
      nextArrow: '<button class="arrow-next"><img src="https://cdn.shopify.com/s/files/1/1303/8939/files/pdp-thumb-down.svg?v=1617313044" alt="product image thumbnail down"></button>',
    };

    // slick options for gallery
    this.mainSliderOptions = {
      asNavFor: $(selectors.thumbnailGallery),
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      dots: true,
      rows: 0,
      infinite: true,
      lazyload: 'progressive',
      prevArrow: '<button class="arrow-previous" aria-label="Previous Image"><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D---Home---Hover" transform="translate(-1254.000000, -2136.000000)" fill="#8DA5C7"> <g id="molecule/pdp/related-products/desktop/default" transform="translate(130.000000, 2133.000000)"> <g id="icon/16px/left" transform="translate(1124.000000, 3.000000)"> <polygon id="Path" transform="translate(8.194400, 8.000000) scale(-1, 1) translate(-8.194400, -8.000000) " points="5.40416 0 3 2.41152 8.57536 8 3 13.58848 5.40416 16 13.3888 8"></polygon></g></g></g></g></svg></button>',
      nextArrow: '<button class="arrow-next" aria-label="Next Image"><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D---Home---Hover" transform="translate(-1294.000000, -2136.000000)" fill="#8DA5C7"> <g id="molecule/pdp/related-products/desktop/default" transform="translate(130.000000, 2133.000000)"> <g id="icon/16px/right" transform="translate(1164.000000, 3.000000)"> <polygon id="Path" points="5.40416 0 3 2.41152 8.57536 8 3 13.58848 5.40416 16 13.3888 8"></polygon></g></g></g></g></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: true,
          },
        },
      ],
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.metafieldsData = JSON.parse($(selectors.metafieldsData).html());
    this.lowStockData = $(selectors.lowStockData, this.$container);
    this.backInStock = $(selectors.backInStock, this.$container);
    this.qtyAddToCartContainer = $(selectors.qtyAddToCartContainer, this.$container);
    this.$qtyInput = $(selectors.qtyInput, this.$container);
    this.$productYmal = $(selectors.productYmal, this.$container);

    this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    this.$dropdownToggler = $(selectors.dropdownToggler, this.$container);
    this.$dropdowns = $(selectors.dropdown, this.$container);
    this.$qtyStepper = $(selectors.qtyStepper, this.$container);
    this.$bisEmailSubmit = $(selectors.bisEmailSubmit, this.$container);
    this.$bisPhoneField = $(selectors.bisPhoneField, this.$container);
    this.$bisPhoneSubmit = $(selectors.bisPhoneSubmit, this.$container);
    this.$installmentOptions = $(selectors.installmentOptions, this.$container);

    this.$dropdownToggler.on('click', this.productDetailToggleDropdown.bind(this));
    this.$qtyStepper.on('click', this.productQty.bind(this));
    this.$qtyInput.on('change', this.validateMaxQty.bind(this));
    this.$bisEmailSubmit.on('click', this.bisEmail.bind(this));
    this.$bisPhoneField.on('keyup', this.updatePhoneStructure.bind(this));
    this.$bisPhoneSubmit.on('click', this.bisPhone.bind(this));
    this.$productYmal.on('click', this.ssClickTrack.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    //zoom gallery selectors and events
    this.$zoomModal = $(selectors.zoomModal, this.$container);
    this.$zoomModalOpen = $(selectors.zoomOpen, this.$container);
    this.$zoomModalClose = $(selectors.zoomClose, this.$container);
    this.$zoomModalThumbnail = $(selectors.zoomThumbnail, this.$container);
    this.$zoomModalImages = $(selectors.zoomImage, this.$container);
    this.$zoomModalGallery = $(selectors.zoomModalGallery, this.$container);

    this.$zoomModalOpen.on('click', this.openZoomModal.bind(this));
    this.$zoomModalClose.on('click', this.closeZoomModal.bind(this));
    this.$zoomModalThumbnail.on('click', this.$scrollToZoomImage.bind(this));

    this.initGalleries();
    this.initGalleryVideo();
    this.initVariantSwatches();
    this.initCompleteTheLookSlider();
    this.initShopMoreColorsSlider();
    if (this.$productYmal.length) {
      this.initProductYmal();
    }
    this.updateViewedProducts();
    this.updateYotpoSnippets();

    this.intersectionObserverOptions = {
      root: this.$zoomModalGallery.get(0),
      threshold: [0.1],
    };
    this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback.bind(this), this.intersectionObserverOptions);
    this.$zoomModalImages.each(function (index, el) {
      self.intersectionObserver.observe(el);
    });

    // Monogramming box selectors and events
    this.$monogrammingToggle = $(selectors.monogrammingToggle, this.$container);
    this.$monogrammingBox = $(selectors.monogrammingBox, this.$container);
    this.$monogrammingModalToggle = $(selectors.monogrammingModalToggle, this.$container);
    this.$monogrammingModal = $(selectors.monogrammingModal, this.$container);
    this.$monogrammingCheckbox = $(selectors.monogrammingCheckbox, this.$container);

    this.$monogrammingToggle.on('click', this.toggleMonogrammingBox.bind(this));
    this.$monogrammingModalToggle.on('click', this.toggleMonogramModal.bind(this));

    // Check for URL structure
    this.checkUrlHash();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    onVariantChange: function (evt) {
      this.updateAddToCartState(evt);
      this.updateVariantMaxQuantity(evt);
      this.updateLowStockMessaging(evt);
      this.updateBISVariant(evt);
      this.updateBadge(evt);
    },

    updateBadge: function (evt) {
      var variant = evt.variant;
      var showVariant = true;
      var tagVariant = '';

      for (let i = 0; i < this.productSingleObject.tags.length; i++) {
        if (this.productSingleObject.tags[i].indexOf('badge:') > -1) {
          var tagVariant = this.productSingleObject.tags[i].replaceAll('badge:', '');
          break;
        }
      }

      if (this.productSingleObject.tags.indexOf('Early Access') > -1) {
        earlyAccess = true;
      }

      if (!variant.available && this.productSingleObject.tags.indexOf('bis-hidden') == -1) {
        const badgeContent = earlyAccess ? 'Early Access' : this.$badgeContainer.data('bis-badge-text');
        this.$badgeContainer.html("<span class='product-card__badge product-card__badge--back-in-stock'>" + badgeContent + '</span>');
      } else if (!variant.available) {
        this.$badgeContainer.html("<span class='product-card__badge product-card__badge--sold-out'>" + this.$badgeContainer.data('oos-badge-text') + '</span>');
      } else if (this.productSingleObject.compare_at_price_max > this.productSingleObject.price) {
        tagVariant = tagVariant + "<span class='product-card__badge'>SALE</span>";
        this.$badgeContainer.html(tagVariant);
      } else if (tagVariant != '') {
        this.$badgeContainer.html("<span class='product-card__badge'>" + tagVariant + '</span>');
      } else {
        showVariant = false;
      }

      if (showVariant) {
        this.$badgeContainer.removeClass('product__gallery-badges--empty');
      } else {
        this.$badgeContainer.addClass('product__gallery-badges--empty');
      }
    },

    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).removeClass('disabled');
        $(selectors.addToCart, this.$container).addClass('btn--secondary');
        if (this.productSingleObject.tags.indexOf('preorder') > -1) {
          $(selectors.addToCartText, this.$container).text($(selectors.addToCartText, this.$container).data('preorder-text'));
        } else {
          $(selectors.addToCartText, this.$container).text('Add to Bag');
        }
        $(selectors.qtyAddToCartContainer, this.$container).show().removeClass('variant-disabled');
        $(selectors.backInStock, this.$container).hide();

        this.$installmentOptions.show();
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true).addClass('disabled');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.qtyAddToCartContainer, this.$container).addClass('variant-disabled');

        if (!$(selectors.qtyAddToCartContainer, this.$container).data('hide-bis')) {
          $(selectors.qtyAddToCartContainer, this.$container).hide();
          $(selectors.backInStock, this.$container).show();

          this.$installmentOptions.hide();
        }
      }
    },

    updateVariantMaxQuantity: function (evt) {
      var variant = evt.variant;
      var variantQuantity = this.metafieldsData[variant.id].variant_qty;
      var $qtyInput = $(selectors.qtyInput, this.$container);
      var currentQty = $qtyInput.val();

      $qtyInput.attr('max', variantQuantity);
      if (currentQty > variantQuantity && variantQuantity > 0) {
        $qtyInput.val(variantQuantity);
      }
    },

    updateLowStockMessaging: function (evt) {
      var variant = evt.variant;
      var lowThreshold = $('.variant-low-stock-title[data-low-stock]').data().lowStock;
      var variantQty = variant.inventory_quantity;
      if (variantQty <= lowThreshold && variant.available && this.productSingleObject.tags.indexOf('preorder') == -1) {
        this.lowStockData.find('p.variant-low-stock-title .low-stock-number').text(variantQty);
        this.lowStockData.show();
      } else {
        this.lowStockData.hide();
      }
    },

    updateBISVariant: function (evt) {
      $('.product__atc-form-container').attr('data-varid', evt.variant.id);
    },

    productDetailToggleDropdown: function (evt) {
      var $this = $(evt.currentTarget);
      var $target = $this.data('toggle');

      if ($('[data-pdp-accordion-content="' + $target + '"]').is(':visible')) {
        $('[data-pdp-accordion-content="' + $target + '"]').slideUp(300);
        $('[data-pdp-accordion-content="' + $target + '"]')
          .siblings('.product__details-menu-title')
          .removeClass('is-open');
        return;
      }

      $('[data-pdp-accordion-content]:visible').siblings('.product__details-menu-title').removeClass('is-open');
      $('[data-pdp-accordion-content]:visible').slideUp(300);
      $('[data-pdp-accordion-content="' + $target + '"]')
        .siblings('.product__details-menu-title')
        .addClass('is-open');
      $('[data-pdp-accordion-content="' + $target + '"]').slideDown(300);
    },

    productQty: function (evt) {
      var $this = $(evt.currentTarget);
      var $qtySelector = $this.parent('[data-qty-container]').find('[data-qty-input]');
      if ($qtySelector.is('[readonly]')) {
        return;
      }
      var qty = parseInt($qtySelector.val());
      var maxQty = parseInt($qtySelector.attr('max'));
      if ($this.hasClass('qtyplus')) {
        qty++;
      } else {
        if (qty > 1) {
          qty--;
        }
      }
      qty = isNaN(qty) ? 1 : qty;
      qty = qty > maxQty && maxQty > 0 ? maxQty : qty;
      $qtySelector.val(qty);
    },

    validateMaxQty: function (evt) {
      var currentValue = $(evt.currentTarget).val();
      var maxQty = this.$qtyInput.attr('max');
      if (parseInt(currentValue) > parseInt(maxQty) && parseInt(maxQty) > 0) {
        this.$qtyInput.val(maxQty);
      }
    },

    bisEmail: function (evt) {
      evt.preventDefault();
      var metaData = null;
      var acceptsMarketing = $('#accept_marketing').is(':checked');
      var email = $('#notify_email').val(),
        productId = $('.product__atc-form-container').attr('data-productid'),
        variantId = $('.product__atc-form-container').attr('data-varid');
      BIS.create(email, variantId, productId, { accepts_marketing: acceptsMarketing, phone_number: null }).then(notificationCallback); // create the notification

      if (!acceptsMarketing) {
        return;
      }
      if (this.productSingleObject?.tags?.includes('Early Access')) {
        metaData = {
          patch_properties: {
            append: {
              'Early Access Products': this.productSingleObject.title,
            },
          },
        };
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=PaitnH', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2024-02-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'BIS Form - Email submission',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                  meta: metaData,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'LzCgke',
                },
              },
            },
          },
        }),
      }).then(() => {
        console.log('Email consent submitted');
      });
    },
    updatePhoneStructure: function (evt) {
      const $this = $(evt.currentTarget);
      let match = $this
        .val()
        .replace(/\D+/g, '')
        .replace(/^1/, '')
        .match(/([^\d]*\d[^\d]*){1,10}$/);

      if (match) {
        match = match[0];
        const part1 = match.length > 3 ? `(${match.substring(0, 3)})` : match;
        const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : '';
        const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : '';

        $this.val(`${part1}${part2}${part3}`);
      }
    },
    bisPhone: function (evt) {
      evt.preventDefault();
      var metaData = null;
      var acceptsMarketing = $('#accept_marketing').is(':checked');
      var listId = $('#notify_sms').data('list-id');
      var sms =
          '+1' +
          $('#notify_sms')
            .val()
            .replaceAll(/[^0-9]+/g, ''),
        productId = (productId = $('.product__atc-form-container').attr('data-productid')),
        variantId = $('.product__atc-form-container').attr('data-varid');
      BIS.create(null, variantId, productId, { accepts_marketing: acceptsMarketing, phone_number: sms }).then(notificationCallback); // create the notification

      // Post phone number to Klaviyo list
      if (!acceptsMarketing) {
        return;
      }

      if (this.productSingleObject?.tags?.includes('Early Access')) {
        metaData = {
          patch_properties: {
            append: {
              'Early Access Products': this.productSingleObject.title,
            },
          },
        };
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=PaitnH', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2024-02-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'BIS Form - SMS submission',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    phone_number: sms,
                  },
                  meta: metaData,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'TneGit',
                },
              },
            },
          },
        }),
      }).then((response) => {
        console.log('SMS consent submitted');
      });
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var monogrammingPrice = 0;

      if (this.$monogrammingCheckbox.is(':checked')) {
        monogrammingPrice = JSON.parse($(selectors.monogrammingProduct, this.$container).html()).variants[0].price;
      }

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price + monogrammingPrice, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price + monogrammingPrice, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * initializes the gallery slider + thumbnail slider
     */
    initVariantSwatches: function () {
      $(document).on('change', '.swatch :radio', function () {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue);
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).trigger('change');
        var swatchName = $(this).parent().parent().find('.js-selectedOption').attr('id');
        $('#' + swatchName + '.js-selectedOption').html(optionValue);
      });
      $(document).on('keydown', '.swatch label', function (e) {
        if (e.keyCode == 13) {
          var labelID = $(this).attr('for');
          $('#' + labelID).trigger('click');
        }
      });
    },

    /**
     * initializes the gallery slider + thumbnail slider
     */
    initGalleries: function () {
      this.initMainGallery();
      this.initThumbnailGallery();
      $(selectors.productGallery).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        const currentS = slick.$slides[slick.currentSlide];
        if (currentS && currentS.dataset.mediaId) {
          const video = currentS.querySelector('video');
          video.play();
        } else {
          const videos = [...document.querySelectorAll(selectors.galleryVideo)];
          videos.map((v) => {
            const video = v.querySelector('video');
            video.pause();
          });
        }
      });
    },

    /**
     * initializes the gallery slider
     */
    initMainGallery: function () {
      $(selectors.productGallery).not('.slick-initialized').slick(this.mainSliderOptions);
    },
    /**
     * initializes the thumbnail slider
     */
    initThumbnailGallery: function () {
      $(selectors.thumbnailGallery, this.$container).not('.slick-initialized').slick(this.thumbnailSliderOptions);
    },

    /**
     * Gallery video: play/pause on click, center play button when paused, mute/unmute in corner.
     * Delegated on document so it works in quick-view and main product gallery.
     */
    initGalleryVideo: function () {
      var self = this;

      $(document).on('click', selectors.galleryVideo, function (evt) {
        var $wrapper = $(evt.currentTarget);
        if (!($(evt.target).closest(selectors.galleryVideoPlay).length || $(evt.target).closest('.product__gallery-video-mute-btn').length)) {
          var video = $wrapper.find('video').get(0);
          if (video) {
            if (video.paused) {
              video.play();
              $wrapper.find(selectors.galleryVideoPlay).removeClass('is-visible');
            } else {
              video.pause();
              $wrapper.find(selectors.galleryVideoPlay).addClass('is-visible');
            }
          }
        }
      });

      $(document).on('click', selectors.galleryVideoPlay, function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var $wrapper = $(evt.currentTarget).closest(selectors.galleryVideo);
        var video = $wrapper.find('video').get(0);
        if (video) {
          video.play();
          $wrapper.find(selectors.galleryVideoPlay).removeClass('is-visible');
        }
      });

      $(document).on('click', selectors.galleryVideoUnmute, function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var $wrapper = $(evt.currentTarget).closest(selectors.galleryVideo);
        var video = $wrapper.find('video').get(0);
        if (video) {
          $(evt.currentTarget).removeClass('is-visible');
          $wrapper.find(selectors.galleryVideoMute).addClass('is-visible');
          video.muted = false;
        }
      });

      $(document).on('click', selectors.galleryVideoMute, function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var $wrapper = $(evt.currentTarget).closest(selectors.galleryVideo);
        var video = $wrapper.find('video').get(0);
        if (video) {
          $(evt.currentTarget).removeClass('is-visible');
          $wrapper.find(selectors.galleryVideoUnmute).addClass('is-visible');
          video.muted = true;
        }
      });

      $(selectors.galleryVideo, self.$container).each(function () {
        var video = this.querySelector('video');
        if (video) {
          video.addEventListener('play', function () {
            $(this).closest(selectors.galleryVideo).find(selectors.galleryVideoPlay).removeClass('is-visible');
          });
          video.addEventListener('pause', function () {
            $(this).closest(selectors.galleryVideo).find(selectors.galleryVideoPlay).addClass('is-visible');
          });
        }
      });
    },
    initCompleteTheLookSlider: function () {
      this.smallSliderSettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        rows: 0,
        prevArrow: '',
        nextArrow: '.complete-the-look [data-arrow-next]',
        responsive: [
          {
            breakpoint: 979,
            settings: {
              infinite: false,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 750,
            settings: {
              infinite: false,
              slidesToShow: 2.2,
              slidesToScroll: 1,
            },
          },
        ],
      };
      if ($(selectors.completeTheLook, this.$container).length) {
        $(selectors.completeTheLook, this.$container).not('.slick-initialized').slick(this.smallSliderSettings);
      }
    },

    initShopMoreColorsSlider: function () {
      this.smallSliderSettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        rows: 0,
        prevArrow: '',
        nextArrow: '.shop-more-colors [data-arrow-next]',
        responsive: [
          {
            breakpoint: 979,
            settings: {
              infinite: false,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 750,
            settings: {
              infinite: false,
              slidesToShow: 2.2,
              slidesToScroll: 1,
            },
          },
        ],
      };
      if ($(selectors.shopMoreColors, this.$container).length) {
        $(selectors.shopMoreColors, this.$container).not('.slick-initialized').slick(this.smallSliderSettings);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },

    initProductYmal() {
      var self = this;
      $.get('/cart.json').done(function (cart) {
        var cartData = [];
        $(cart.items).each(function (index, item) {
          cartData.push(item.sku);
        });
        var viewedProducts = Cookies.get('ss-viewed-products') || '';

        $.ajax({
          url: 'https://do4xra.a.searchspring.io/boost/do4xra/recommend',
          data: JSON.stringify({
            shopper: window.SHOPIFY_CUSTOMER_ID,
            tags: ['customers-also-viewed'],
            limit: 20,
            cart: cartData,
            product: self.productSingleObject.variants[0].sku,
            lastViewed: viewedProducts.split(','),
          }),
          dataType: 'JSON',
          contentType: 'application/json',
          method: 'POST',
        })
          .done(function (response) {
            self.ssRenderTrack.call(self, response);
            response[0].results.map(function (item) {
              item.stringMappings = JSON.stringify(item.mappings);
              if (item.mappings.core.msrp != 0) {
                item.mappings.core.msrp = slate.Currency.formatMoney(item.mappings.core.msrp * 100, window.theme.moneyFormat);
              } else {
                item.mappings.core.msrp == '';
              }
              item.mappings.core.price = slate.Currency.formatMoney(item.mappings.core.price * 100, window.theme.moneyFormat);
              item.mappings.core.imageUrl = item.attributes.ss_image || item.mappings.core.imageUrl;
              item.mappings.core.imageUrl = item.mappings.core.imageUrl.replace('600x600', '300x300');
              if (item.attributes.tags) {
                for (i = 0; i < item.attributes.tags.length; i++) {
                  if (item.badge !== '') {
                    break;
                  }

                  if (item.attributes.tags[i].indexOf('badge:')) {
                    var badge_parts = item.attributes.tags[i].split('badge:');
                    item.badge = badge_parts[1];
                  }
                }
              }

              if (item.ss_available === '0' && item.attributes.tags.length && item.attributes.tags.indexOf('bis-hidden') == -1) {
                item.badge = window.theme.strings.bisBadge;
                item.badge_type = 'product-card__badge--back-in-stock';
              } else if (item.ss_available === '0') {
                item.badge = window.theme.strings.oosBadge;
              } else if (item.attributes.tags.length && item.attributes.tags.indexOf('preorder') != -1) {
                item.badge = 'Pre-order';
                console.log(item);
                item.badge_type = 'product-card__badge--preorder';
              } else if (item.mappings.core.msrp != 0) {
                item.badge = 'Sale';
              }

              return item;
            });

            var dataProductYmal = $('[data-product-ymal]');
            var ymalTemplate = Handlebars.compile($('[data-product-ymal-template]').html());
            var ymalData = ymalTemplate(response[0]);

            dataProductYmal.html(ymalData);
            self.initYmalSlider();
          })
          .fail(function (xhr, response) {
            console.error(response);
          });
      });
    },

    initYmalSlider() {
      var dataProductYmal = $('[data-product-ymal]', this.$container);
      var nextArrow = $('.featured-collection [data-arrow-next]');
      var prevArrow = $('.featured-collection [data-arrow-prev]');
      var slickOptions = {
        slidesToShow: 7,
        slidesToScroll: 5,
        infinite: false,
        dots: true,
        prevArrow,
        nextArrow,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 6.2,
            },
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 2,
            },
          },
        ],
      };
      if (dataProductYmal.length) {
        dataProductYmal.not('.slick-initialized').slick(slickOptions);
      }
    },
    openZoomModal(evt) {
      var $this = $(evt.currentTarget);
      var imageIndex = $this.data('image-index');
      var scrollSpeed = 300 * (imageIndex + 1);
      this.$zoomModal.addClass(classes.modalOpen);
      $('html').addClass('no-scroll');

      this.$zoomModalThumbnail.eq(imageIndex).removeClass(classes.active);
      this.$zoomModalImages.removeClass(classes.mobileVisible);

      this.$zoomModalThumbnail.eq(imageIndex).addClass(classes.active);
      this.$zoomModalImages.eq(imageIndex).addClass(classes.mobileVisible);
      if ($(window).outerWidth() > 992) {
        this.$zoomModalGallery.animate(
          {
            scrollTop: this.$zoomModalImages.eq(imageIndex).offset().top,
          },
          scrollSpeed,
        );
      } else {
        this.$zoomModalGallery.scrollLeft((this.$zoomModalGallery.get('0').scrollWidth - this.$zoomModalGallery.outerWidth()) / 2);
      }
    },
    intersectionObserverCallback: function (entries) {
      var self = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var targetIndex = $(entry.target).data('image-index');

          self.$zoomModalImages.removeClass(classes.mobileVisible);
          self.$zoomModalThumbnail.removeClass(classes.active);

          self.$zoomModalImages.eq(targetIndex).addClass(classes.mobileVisible);
          self.$zoomModalThumbnail.eq(targetIndex).addClass(classes.active);
        }
      });
    },
    closeZoomModal: function () {
      this.$zoomModal.removeClass(classes.modalOpen);
      $('html').removeClass('no-scroll');
    },
    $scrollToZoomImage: function (evt) {
      var $this = $(evt.currentTarget);
      var currentIndex = $this.data('image-index');

      if ($this.hasClass(classes.active)) {
        return;
      }

      this.$zoomModalGallery.animate(
        {
          scrollTop: this.$zoomModalImages.eq(currentIndex).outerHeight() * currentIndex,
        },
        500,
      );
    },
    updateViewedProducts: function () {
      var viewedProducts = Cookies.get('ss-viewed-products') || '';
      var newViewedProducts = '';

      if (viewedProducts == '') {
        newViewedProducts = this.productSingleObject.variants[0].sku;
      } else {
        viewedProducts = viewedProducts.split(',').slice(0, 4);
        newViewedProducts = this.productSingleObject.variants[0].sku;
        viewedProducts.forEach(function (sku, index) {
          if (newViewedProducts.indexOf(sku) === -1) {
            newViewedProducts += ',' + sku;
          }
        });
      }

      Cookies.set('ss-viewed-products', newViewedProducts);
    },
    ssRenderTrack: function (response) {
      var self = this;
      var commonId = uuidv4();
      var beaconData = [
        {
          type: 'profile.render',
          category: 'searchspring.recommendations.user-interactions',
          id: commonId,
          pid: null,
          event: {
            profile: {
              tag: 'customers-also-viewed',
              placement: 'product-page',
              seed: self.productSingleObject.variants[0].sku,
            },
            context: {
              type: 'product-recommendation',
              tag: 'customers-also-viewed',
              placement: 'product-page',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        },
      ];

      response[0].results.forEach(function (item) {
        var productRenderData = {
          type: 'profile.product.render',
          category: 'searchspring.recommendations.user-interactions',
          id: uuidv4(),
          pid: commonId,
          event: {
            product: {
              id: item.id,
              seed: self.productSingleObject.variants[0].sku,
              mappings: item.mappings,
            },
            context: {
              type: 'product-recommendation',
              tag: 'product-page',
              placement: 'product-page',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        };

        beaconData.push(productRenderData);
      });

      beaconData.forEach(function (item) {
        if (item.type == 'profile.render') {
          var newType = 'profile.impression';
        } else if (item.type == 'profile.product.render') {
          var newType = 'profile.product.impression';
        }
        var impressionData = Object.assign({}, item, {
          type: newType,
          id: uuidv4(),
          pid: commonId,
        });

        beaconData.push(impressionData);
      });

      $.ajax({
        url: 'https://beacon.searchspring.io/beacon',
        dataType: 'JSON',
        data: JSON.stringify(beaconData),
        contentType: 'application/json',
        method: 'POST',
      });
    },
    ssClickTrack: function (evt) {
      var $target = $(evt.target);
      var $card = $target.closest(selectors.searchSrpingProduct);
      var commonId = uuidv4();
      var beaconData = [
        {
          type: 'profile.click',
          category: 'searchspring.recommendations.user-interactions',
          id: commonId,
          pid: null,
          event: {
            profile: {
              tag: 'customers-also-viewed',
              placement: 'product-page',
              seed: this.productSingleObject.variants[0].sku,
            },
            context: {
              type: 'product-recommendation',
              tag: 'customers-also-viewed',
              placement: 'product-page',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        },
      ];
      if ($card.length > 0) {
        var productId = $card.data('product-id');
        var mappings = $card.data('product-data');
        var productClick = {
          type: 'profile.product.click',
          category: 'searchspring.recommendations.user-interactions',
          id: uuidv4(),
          pid: commonId,
          event: {
            product: {
              id: productId,
              seed: this.productSingleObject.variants[0].sku,
              mappings: mappings,
            },
            context: {
              type: 'product-recommendation',
              tag: 'product-page',
              placement: 'product-page',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        };

        beaconData.push(productClick);
      }
      ga('send', 'event', 'personalized-recommendations', 'recommendations-click', 'also-viewed');
      $.ajax({
        url: 'https://beacon.searchspring.io/beacon',
        dataType: 'JSON',
        data: JSON.stringify(beaconData),
        contentType: 'application/json',
        method: 'POST',
      });
    },
    toggleMonogrammingBox() {
      this.$monogrammingBox.toggleClass(classes.monogrammingOpen);

      if (this.$monogrammingCheckbox.attr('checked')) {
        this.$monogrammingCheckbox.removeAttr('checked');
      } else {
        this.$monogrammingCheckbox.attr('checked', !this.$monogrammingCheckbox.is('checked'));
      }

      var productPrice = this.variants._getVariantFromOptions().price;
      var productComparePrice = this.variants._getVariantFromOptions().compare_at_price;
      var monogrammingPrice = JSON.parse($(selectors.monogrammingProduct, this.$container).html()).variants[0].price;

      if (this.$monogrammingCheckbox.is(':checked')) {
        $(selectors.comparePrice, this.$container).text(slate.Currency.formatMoney(productComparePrice + monogrammingPrice, theme.moneyFormat));
        $(selectors.productPrice, this.$container).text(slate.Currency.formatMoney(productPrice + monogrammingPrice, theme.moneyFormat));
      } else {
        $(selectors.comparePrice, this.$container).text(slate.Currency.formatMoney(productComparePrice, theme.moneyFormat));
        $(selectors.productPrice, this.$container).text(slate.Currency.formatMoney(productPrice, theme.moneyFormat));
      }

      if (this.$monogrammingBox.hasClass(classes.monogrammingOpen)) {
        console.log(this.$qtyInput);
        this.$qtyInput.val(1);
        this.$qtyInput.prop('readonly', true);
      } else {
        this.$qtyInput.prop('readonly', false);
      }
    },
    toggleMonogramModal() {
      this.$monogrammingModal.toggleClass(classes.active);
      $('html').toggleClass('no-scroll');
      $(selectors.monogrammingModalOverlay).toggleClass(classes.active);
    },

    updateYotpoSnippets() {
      if (typeof yotpoWidgetsContainer !== 'undefined') {
        setTimeout(() => {
          yotpoWidgetsContainer.initWidgets();
        }, 100);
      }
    },
    checkUrlHash() {
      var hash = document.location.hash;

      if (hash == '#size-guide') {
        this.openSizeGuideModal();
      }
    },
    openSizeGuideModal() {
      $(selectors.sizeGuideButton).trigger('click');
    },
  });

  return Product;
})($);

/**
   *  Accordion section constructor.
 *
   * @namespace Accordion
 */
theme.Accordion = (function () {

    var selectors = {
        accordion: '[data-accordion]',
        accordionTrigger: '[data-accordion-trigger]',
        accordionQuestion: '[data-accordion-question]',
        accordionAnswer: '[data-accordion-answer]',
    };

    var classes = {
    }

    function Accordion(container) {
        this.name = "accordion";
        this.namespace = '.' + this.name;
        this.$container = $(container);

        $(selectors.accordion).each(function(index) {
            $(this).attr('data-accordion-id', index)
        })

        $(selectors.accordionTrigger).unbind().click(function() {
            openAccordion($(this))
        })

        function openAccordion(element) {
            var index = element.closest(selectors.accordion).attr('data-accordion-id')
            var currentAccordion = $('[data-accordion-id="' + index + '"]')
            var open = currentAccordion.hasClass('open')
            
            if(open) {
                currentAccordion.removeClass('open')
                currentAccordion.find(selectors.accordionAnswer).slideUp()
            } else {
                currentAccordion.addClass('open')
                currentAccordion.find(selectors.accordionAnswer).slideDown()
            }
        }
    }

    return Accordion;

})();

/**
   * Modal section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
 *
   * @namespace modal
 */
theme.Modal = (function ($) {

    var selectors = {
      modal: '[data-modal]',
      modalOverlay: '[data-modal-overlay]',
      modalWrapper: '[data-modal-wrapper]',
      modalTrigger: '[data-modal-trigger]',
      modalTemplate: '[data-modal-template]',
      modalClose: '[data-modal-close]'
    };

    function Modal(container) {
      this.name = "modal";
      this.namespace = '.' + this.name;
      this.$container = $(container);

      $("body").on('click', selectors.modalTrigger, this.openModal.bind(this));
      $("body").on('click', selectors.modalClose, this.closeModal.bind(this));
      $("body").on('click', selectors.modalOverlay, this.closeModal.bind(this));
      this.product = null;
    }

    Modal.prototype = $.extend({}, Modal.prototype, {
      openModal: function(event) {
        var currentElement = $(event.currentTarget)
        var template = currentElement.attr('data-modal-template')
        var resource = currentElement.attr('data-modal-trigger')
        var smoothHref = currentElement.attr('href')

        this.getAlternativeTemplate(resource, template, false)
            .then(function(res) {
                $("body").addClass('no-scroll');
                $(selectors.modalOverlay).addClass('is-active')
                $(selectors.modalWrapper).addClass('is-active')
                $(selectors.modalWrapper).empty()
                $(selectors.modalWrapper).append(res)

                if(template == 'quick-view') {
                  this.product = new theme.Product($('[data-section-type="product"]'));
                }
            })
            .then(function(res) {
              if(window.location.hash === smoothHref) {
                setTimeout(function(){
                  document.querySelector(window.location.hash).scrollIntoView({
                    behavior: 'smooth'
                  });
                  checkActiveLink()
                }, 1000);
              } else if (template === "image-gallery-zoom-mobile") {
                checkActiveLink(smoothHref)
              }
            });
      },

      closeModal: function() {
          $("body").removeClass('no-scroll');
          $(selectors.modalOverlay).removeClass('is-active')
          $(selectors.modalWrapper).removeClass('is-active')
          $(selectors.modalWrapper).empty();
      },

      getAlternativeTemplate: function(resource, templateName, json = false) {
        var url = "/" + resource + "?view=" + templateName;
        var options = { credentials: 'include' };
        return fetch(url, options).then(res => (json) ? res.json() : res.text());
      },

      checkActiveLink: function(acitveLink = false) {
          $('[data-url-active-link]').each(function( index ) {
            $(this).removeClass('active')
            if(window.location.hash === $(this).attr('href') || window.location.hash === $(this).attr('id') || acitveLink === $(this).attr('href')) {
              $(this).addClass("active")
              $(this).focus()
            }
          });
      }
    })

    return Modal;
  })($);

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace video
 */

theme.Video = (function () {
  var selectors = {
    videoWrapper: '[data-video-wrapper]',
    video: '[data-video]',
    playButton: '[data-play-button]',
    mute: '[data-mute]',
    unmute: '[data-unmute]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Video(container) {
    var $container = $(container);
    var $wrappers = $container.is(selectors.videoWrapper) ? $container : $container.find(selectors.videoWrapper);

    function hideButton() {
      $container.find(selectors.playButton).css({ opacity: 0, zIndex: -1 });
    }

    function showButton() {
      $container.find(selectors.playButton).css({ opacity: 1, zIndex: '' });
    }

    function tryAutoplay($video) {
      if (!$video || $video.length === 0) return;

      var videoEl = $video.get(0);
      if (!videoEl) return;
      if (!$video.is('[autoplay]')) return;

      // Autoplay is commonly blocked unless muted (especially iOS/Safari).
      videoEl.muted = true;

      var attemptPlay = function () {
        var playPromise = videoEl.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      };

      if (videoEl.readyState >= 2) {
        attemptPlay();
      } else {
        $video.one('loadedmetadata canplay', attemptPlay);
      }

      // Some browsers defer autoplay; quick retries help.
      window.requestAnimationFrame(attemptPlay);
      window.setTimeout(attemptPlay, 250);
    }

    $wrappers.each(function () {
      tryAutoplay($(this).find(selectors.video));
    });

    $container.on('click', selectors.playButton, function () {
      var $wrapper = $(this).closest(selectors.videoWrapper);
      var $video = $wrapper.find(selectors.video);
      if ($video.length > 0) {
        var videoEl = $video.get(0);
        if (videoEl.paused) {
          videoEl.play();
          hideButton();
        } else {
          videoEl.pause();
          showButton();
        }
      }
    });

    // When autoplay is disabled, allow pausing/resuming by clicking the video.
    $container.on('click', selectors.video, function (evt) {
      var $video = $(evt.currentTarget);
      var $wrapper = $video.closest(selectors.videoWrapper);
      var hasPlayButton = $wrapper.find(selectors.playButton).length > 0;
      if (!hasPlayButton) return;

      var videoEl = $video.get(0);
      if (videoEl.paused) {
        videoEl.play();
        hideButton();
      } else {
        videoEl.pause();
        showButton();
      }
    });

    // Keep button state in sync if video is paused/played externally.
    $container.on('play', selectors.video, function () {
      hideButton();
    });
    $container.on('pause ended', selectors.video, function (evt) {
      var $video = $(evt.currentTarget);
      var $wrapper = $video.closest(selectors.videoWrapper);
      var hasPlayButton = $wrapper.find(selectors.playButton).length > 0;
      if (hasPlayButton) showButton();
    });

    $container.on('click', selectors.mute, function () {
      var $wrapper = $(this).closest(selectors.videoWrapper);
      var $video = $wrapper.find(selectors.video);
      if ($video.length > 0) {
        $(this).removeClass('active');
        $wrapper.find(selectors.unmute).addClass('active');
        $video.prop('muted', true);
      }
    });

    $container.on('click', selectors.unmute, function () {
      var $wrapper = $(this).closest(selectors.videoWrapper);
      var $video = $wrapper.find(selectors.video);
      if ($video.length > 0) {
        $(this).removeClass('active');
        $wrapper.find(selectors.mute).addClass('active');
        $video.prop('muted', false);
      }
    });
  }

  return Video;
})();

/**
   * FeaturedCollection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
 *
   * @namespace featuredCollection
 */
theme.FeaturedCollection = (function () {

  var selectors = {
    slider: '[data-slider-container]',
    slide: '[data-slider-slide]',
    nextArrow: '[data-arrow-next]',
    prevArrow: '[data-arrow-prev]',
  };

  function FeaturedCollection(container) {
    this.name = "featuredCollection";
    this.namespace = '.' + this.name;
    this.$container = $(container);

    this.nextArrow = $(selectors.nextArrow, this.$container);
    this.prevArrow = $(selectors.prevArrow, this.$container);

    this.slickOptions = {
      slidesToShow: 4.2,
      slidesToScroll: 4,
      infinite: false,
      dots: true,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 2,
          }
        }
      ]
    }

    this.$sliderContainer = $(selectors.slider, this.$container);

    this.initSlider();
  }

  FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
    initSlider() {
      this.$sliderContainer.slick(this.slickOptions);
    },
    onSectionLoad() {
      this.$sliderContainer.slick(this.slickOptions);
    }
  });

  return FeaturedCollection; // where does this get executed?
})();

/**
 * Swatches section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 *
 * @namespace swatches
 */

 theme.Swatches = (function () {

  var selectors = {
  };

  var classes = {
  }

  function Swatches(container) {
    this.name = "swatches";
    this.namespace = '.' + this.name;
    this.$container = $(container);
  }

  Swatches.prototype = $.extend({}, Swatches.prototype, {
    onSelect: function() {
      this.$container.slideDown();
    },
    onDeselect: function() {
      this.$container.slideUp();
    }
  });

  return Swatches; // where does this get executed?
})();

/**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
 *
   * @namespace birthday-capture
 */
 theme.BirthdayCapture = (function () {

  var selectors = {
    birthdayForm: '[data-birthday-form]',
    birthdayField: '[data-birthday-field]',
    birthdayEdit: '[data-birthday-edit]',
    birthdayContainer: '[data-birthday-date]',
    birthdayCancel: '.cancel-birthday'
  };

  function BirthdayCapture(container) {
    this.name = "birthday-capture";
    this.namespace = "." + this.name;
    this.$container = $(container);

    // DOM Cache
    this.$birthdayForm = $(selectors.birthdayForm, this.$container);
    this.$birthdayField = $(selectors.birthdayField, this.$container);
    this.$birthdayContainer = $(selectors.birthdayContainer, this.$container);
    this.$birthdayEdit = $(selectors.birthdayEdit, this.$container);
    this.$birthdayCancel = $(selectors.birthdayCancel, this.$container);

    this.customerBirthday = Cookies.get('customerBirthday');
    this.submittedBirthday = Cookies.get('birthdaySent');

    // Events
    this.$birthdayForm.on('submit', this.onFormSubmit.bind(this));
    this.$birthdayField.on('change', this.onFieldChange.bind(this));
    this.$birthdayEdit.on('click', this.birthdayEditToggle.bind(this));
    this.$birthdayCancel.on('click', this.birthdayEditToggle.bind(this));
    this.checkBirthdaySubmitted();
  }

  BirthdayCapture.prototype = $.extend({}, BirthdayCapture.prototype, {
    onFormSubmit: function(evt) {
      if(evt) {
        evt.preventDefault();
      }
      var self = this;

      var customerEmail = window.customer.email;
      var customerBirthday = this.$birthdayField.val();
      Cookies.set('customerBirthday', customerBirthday);

      if(customerBirthday != '') {
        const options = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            revision: '2024-02-15'
          },
          body: JSON.stringify({
            data: {
              "type": "profile",
              "attributes": {
                "email": customerEmail,
                "properties": {
                  "$birthday": customerBirthday
                }
              },
            }
          })
        };

        fetch('https://a.klaviyo.com/client/profiles/?company_id=PaitnH', options)
        .then( function() {Cookies.set('birthdaySent', true);
          self.$birthdayForm.hide();
          self.$birthdayEdit.show();
          self.$birthdayContainer.text(customerBirthday).show();}
        )
      }
    },

    birthdayEditToggle: function() {
      this.$birthdayContainer.toggle();
      this.$birthdayEdit.toggle();
      this.$birthdayForm.toggle();
    },

    checkBirthdaySubmitted: function() {
      if(this.submittedBirthday === 'true' && (this.customerBirthday !== "" && typeof this.customerBirthday !== "undefined")) {
        this.$birthdayField.val(this.customerBirthday);
        this.$birthdayContainer.text(this.customerBirthday).show();
      } else if(typeof this.customerBirthday !== 'undefined') {
        this.$birthdayField.val(this.customerBirthday);
        this.onFormSubmit.call(this);
      } else {
        this.$birthdayForm.show();
        this.$birthdayEdit.hide();
      }
    },

    onFieldChange: function(evt) {
      var $this = $(evt.currentTarget);
      var $siblings = $this.siblings('input[type=date]');
      if($this.val() !== '') {
        $this.removeAttr('placeholder');
        $siblings.removeAttr('placeholder');
      } else {
        $this.attr('placeholder', 'mm/dd/yyyy');
        $siblings.attr('placeholder', 'mm/dd/yyyy');
      }
    }

  });

  return BirthdayCapture; // where does this get executed?
})();
/**
 * Gift Card Recipient Form
 * ------------------------------------------------------------------------------
 * Powers the "For Myself / Send as a Gift" tabs on gift card PDPs.
 * Uses Shopify's native gift card recipient line item properties, so Shopify
 * emails the gift card to the recipient on the selected date (or immediately
 * after payment when no date is selected).
 *
 * @namespace giftCardRecipient
 */

theme.GiftCardRecipient = (function ($) {
  var selectors = {
    container: '[data-gift-recipient]',
    tab: '[data-gift-recipient-tab]',
    panel: '[data-gift-recipient-panel]',
    checkbox: '[data-gift-recipient-checkbox]',
    field: '[data-gift-recipient-field]',
    email: '[data-gift-recipient-email]',
    emailError: '[data-gift-recipient-email-error]',
    message: '[data-gift-recipient-message]',
    counter: '[data-gift-recipient-counter]',
    date: '[data-gift-recipient-date]',
    offset: '[data-gift-recipient-offset]',
    mirror: '[data-gift-recipient-mirror]',
    addToCart: '[data-add-to-cart]',
    productForm: '[data-product-form]',
  };

  var classes = {
    active: 'is-active',
    recipientMode: 'gift-recipient--active',
    inputError: 'gift-recipient__input--error',
  };

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isRecipientMode($container) {
    return $container.hasClass(classes.recipientMode);
  }

  function setMode($container, mode) {
    var recipient = mode === 'recipient';
    var $panel = $container.find(selectors.panel);
    var $checkbox = $container.find(selectors.checkbox);
    var $fields = $container.find(selectors.field);

    $container.toggleClass(classes.recipientMode, recipient);

    $container.find(selectors.tab).each(function () {
      var active = $(this).data('gift-recipient-tab') === mode;
      $(this)
        .toggleClass(classes.active, active)
        .attr('aria-selected', active ? 'true' : 'false');
    });

    if (recipient) {
      $panel.removeAttr('hidden');
      $fields.prop('disabled', false);
      $checkbox.prop('disabled', false).prop('checked', true);
      initDatepicker($container.find(selectors.date)[0]);
      syncOffset($container);
    } else {
      $panel.attr('hidden', true);
      $fields.prop('disabled', true);
      $checkbox.prop('disabled', true).prop('checked', false);
      clearErrors($container);
    }
  }

  function initDatepicker(dateInput) {
    if (!dateInput || dateInput._flatpickr || typeof flatpickr === 'undefined') {
      return;
    }

    var maxDays = parseInt(dateInput.getAttribute('data-gift-recipient-max-days'), 10) || 90;
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + maxDays);

    flatpickr(dateInput, {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'F j, Y',
      minDate: 'today',
      maxDate: maxDate,
      defaultDate: 'today',
      disableMobile: true,
    });
  }

  function syncOffset($container) {
    var $offset = $container.find(selectors.offset);
    var hasDate = $container.find(selectors.date).val() !== '';

    $offset.val(new Date().getTimezoneOffset().toString()).prop('disabled', !hasDate || !isRecipientMode($container));
  }

  function clearErrors($container) {
    $container.find(selectors.emailError).attr('hidden', true);
    $container.find(selectors.email).removeClass(classes.inputError);
  }

  function validate($container) {
    var $email = $container.find(selectors.email);
    var value = $.trim($email.val());
    var valid = emailPattern.test(value);

    clearErrors($container);

    if (!valid) {
      $email.addClass(classes.inputError);
      $container.find(selectors.emailError).removeAttr('hidden');
      $email.trigger('focus');
    }

    return valid;
  }

  function updateCounter(textarea) {
    var $textarea = $(textarea);
    var max = $textarea.attr('maxlength') || 200;
    $textarea
      .closest('.gift-recipient__field')
      .find(selectors.counter)
      .text($textarea.val().length + '/' + max);
  }

  function ensureSendDate($container) {
    var dateInput = $container.find(selectors.date)[0];
    if (dateInput && dateInput._flatpickr && dateInput.value === '') {
      dateInput._flatpickr.setDate('today', true);
    }
  }

  function syncMirrors($container) {
    $container.find(selectors.mirror).each(function () {
      var sourceName = 'properties[' + $(this).data('gift-recipient-mirror') + ']';
      var $source = $container.find('[name="' + sourceName + '"]');
      $(this).val($.trim($source.val() || ''));
    });
  }

  function dropEmptyOptionalFields($container) {
    var $empty = $container.find(selectors.field).filter(function () {
      return !this.disabled && $.trim($(this).val()) === '';
    });

    if (!$empty.length) {
      return;
    }

    $empty.prop('disabled', true);
    setTimeout(function () {
      $empty.prop('disabled', false);
    }, 0);
  }

  function onAddToCartCapture(event) {
    var button = event.target.closest ? event.target.closest(selectors.addToCart) : null;
    if (!button) {
      return;
    }

    var $form = $(button).closest(selectors.productForm);
    var $container = $form.find(selectors.container);

    if (!$container.length || !isRecipientMode($container)) {
      return;
    }

    if (!validate($container)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    ensureSendDate($container);
    syncOffset($container);
    syncMirrors($container);
    dropEmptyOptionalFields($container);
  }

  function init() {
    $(document).on('click', selectors.tab, function () {
      var $container = $(this).closest(selectors.container);
      setMode($container, $(this).data('gift-recipient-tab'));
    });

    $(document).on('input', selectors.message, function () {
      updateCounter(this);
    });

    $(document).on('change', selectors.date, function () {
      syncOffset($(this).closest(selectors.container));
    });

    $(document).on('focusin', selectors.date, function () {
      initDatepicker(this);
    });

    document.addEventListener('click', onAddToCartCapture, true);
  }

  return {
    init: init,
  };
})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $('[data-account-details], [data-account-address-forms]').toggleClass('hide');
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('[data-account-details], [data-account-address-forms]').toggleClass('hide');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Collection template constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 *
 * @namespace collection
 */
theme.Collection = (function ($) {
  var selectors = {
    headerContainer: '[data-header-container]',
    mobileFilters: '[data-mobile-filters]',
    ssContainer: '[data-ss-container]',
    productGrid: '[data-product-grid]',
    paginationContainer: '[data-pagination-container]',
    ssTemplate: '[data-ss-template]',
    ssResultsTemplate: '[data-ss-results-template]',
    paginationItem: '[data-pagination-item]',
    sortSelect: '[data-sort-by]',
    filtersSidebar: '[data-filters-sidebar]',
    filtersSidebarToggler: '[data-filter-toggler]',
    filterCheckbox: '[data-filter]',
    filterGroupHeader: '[data-filter-group-header]',
    sortContainer: '[data-sort-bar-container]',
    loadMoreButton: '[data-load-more-button]',
    productGrid: '[data-product-grid]',
    sidebar: '[data-filters-sidebar]',
    removeFilterButton: '[data-remove-tag]',
    header: '[data-header]',
    removeFilterButton: '[data-remove-tag]',
    clearFilters: '[data-clear-filters]',
  };

  var classes = {
    seoLongText: 'collection-page__seo-text-description--full',
    mobileOpen: 'mobile-open',
    sidebarEnabled: 'sidebar-enabled',
    mobileSticky: 'mobile-sticky',
    open: 'is-open',
    templateLoaded: 'searchspring-template--loaded',
  };

  function Collection(container) {
    this.name = 'collection';
    this.namespace = '.' + this.name;
    this.$container = $(container);
    this.collectionId = this.$container.data('collection-id');

    this.$ssContainer = $(selectors.ssContainer, this.$container);
    this.$resultsContainer = $(selectors.resultsContainer, this.$container);
    this.$headerContainer = $(selectors.headerContainer, this.$container);
    this.$header = $(selectors.header);
    this.$formField = $(selectors.formField, this.$container);
    this.scrollThreshold = this.$container.data('scroll-threshold');
    this.enableLoadMore = this.$container.data('enable-load-more');
    this.productsPerPage = this.$container.data('products-per-page');
    this.discountMessage = this.$container.data('discount-message');

    this.ssTemplate = Handlebars.compile($(selectors.ssTemplate).html());
    this.ssResultsTemplate = Handlebars.compile($(selectors.ssResultsTemplate).html());

    this.$container.on('change', selectors.sortSelect, this.onFilterChange.bind(this));
    this.$container.on('change', selectors.filterCheckbox, this.onFilterChange.bind(this));
    this.$container.on('click', selectors.loadMoreButton, this.onLoadMoreButtonClick.bind(this));
    this.$container.on('click', selectors.filtersSidebarToggler, this.toggleFiltersSidebar.bind(this));

    this.matchMedia = window.matchMedia('(min-width: 980px)');

    this.$container.on('click', selectors.paginationItem, this.paginateItems.bind(this));
    this.$container.on('click', 'a', this.ssTrackClick.bind(this));
    this.$container.on('click', 'a', this.updateReturnState.bind(this));
    this.$container.on('click', selectors.removeFilterButton, this.removeFilter.bind(this));
    this.$container.on('click', selectors.clearFilters, this.clearFilters.bind(this));
    this.$container.on('click', selectors.filterGroupHeader, this.toggleFilterGroup.bind(this));

    $(window).on('resize', $.throttle(100, this.onScreenResize.bind(this)));
    $(window).on('popstate', this.onBrowserBackClick.bind(this));

    if (this.scrollThreshold > 0 && this.enableLoadMore) {
      $(window).on('scroll', $.throttle(100, this.checkScrollPosition.bind(this)));
    }

    window.history.scrollRestoration = 'manual';

    this.buildUUID();
    this.performSearch(false, document.location.search);
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    refreshYotpoWidgets() {
      setTimeout(() => {
        if (typeof yotpoWidgetsContainer !== 'undefined') {
          setTimeout(() => {
            yotpoWidgetsContainer.initWidgets();
          }, 100);
        } else {
          this.refreshYotpoWidgets();
        }
      }, 1000);
    },
    stickyMobileMenu() {
      var headerHeight = this.$header.outerHeight();
      var $mobileFilters = $(selectors.mobileFilters, this.$container);

      if (!this.matchMedia.matches) {
        $mobileFilters.css({ top: headerHeight });
      } else {
        $mobileFilters.removeAttr('style');
      }
    },

    buildUUID: function () {
      if (typeof Cookies.get('ssSessionIdNamespace') !== 'undefined') {
        Cookies.set('ssSessionIdNamespace', uuidv4());
      }

      if (typeof Cookies.get('ssUserId') !== 'undefined') {
        Cookies.set('ssUserId', uuidv4());
      }

      Cookies.set('ssPageloadId', uuidv4());
    },

    buildQueryString: function (queryString) {
      const urlParams = new URLSearchParams(document.location.search);
      queryString = new URLSearchParams(queryString);
      queryString.set('siteId', 'do4xra');
      queryString.set('resultsFormat', 'native');
      queryString.set('domain', window.location.origin + window.location.pathname);
      queryString.set('resultsPerPage', this.productsPerPage || 48);
      queryString.set('page', urlParams.get('page') || 1);
      queryString.set('bgfilter.ss_is_published', 1);
      queryString.set('bgfilter.collection_handle', this.collectionId);

      return queryString;
    },

    onFilterChange: function (evt) {
      var $this = $(evt.currentTarget);
      if ($this.is('select')) {
        $(selectors.sortSelect).val($this.val());
      }
      this.performSearch(true);
    },

    performSearch: function (updateHistoryState, queryParam, targetPage, addCards, buildFilters = true) {
      var self = this;
      var queryString;

      if (this.searching == true) {
        return;
      }

      if (typeof Cookies.get('ssSessionIdNamespace') == 'undefined') {
        this.buildUUID();
      }

      queryString = this.buildQueryString(queryParam);
      if (buildFilters) {
        this.addSortOptions(queryString);
        this.addFilters(queryString);
      }

      if (targetPage !== undefined && targetPage !== null) {
        queryString.set('page', targetPage);
      } else if (queryString.get('page') === null) {
        queryString.set('page', 1);
      }

      this.searching = true;

      $.ajax({
        url: 'https://do4xra.a.searchspring.io/api/search/search.json',
        method: 'GET',
        headers: {
          'searchspring-session-id': Cookies.get('ssSessionIdNamespace'),
          'searchspring-user-id': Cookies.get('ssUserId'),
          'searchspring-page-load-id': Cookies.get('ssPageloadId'),
        },
        dataType: 'JSON',
        data: queryString.toString(),
      })
        .done(function (response) {
          var $loadMoreButton = $(selectors.loadMoreButton);
          if (response.merchandising.redirect) {
            document.location.href = response.merchandising.redirect;
          }

          if (response.merchandising.content.header) {
            response.header_banner = response.merchandising.content.header;
          }

          if (response.merchandising.content.footer) {
            response.footer_banner = response.merchandising.content.footer;
          }

          if (response.merchandising.content.left) {
            response.left_banner = response.merchandising.content.left;
          }

          if (response.merchandising.content.inline) {
            response.merchandising.content.inline.forEach(function (item) {
              response.results.splice(item.config.position.index, 0, {
                is_banner: true,
                content: item.value,
              });
            });
          }

          if (addCards) {
            self.buildProductCards.call(self, response, queryString);
          } else {
            response = self.buildFiltersAndSort.call(self, response);
            response = self.buildPaginationTemplate.call(self, response);
            self.buildResultTemplate.call(self, response, queryString);
          }

          self.initSidebar();

          if (addCards !== true) {
            $(window).scrollTop(0);
            self.scrollToCard.call(self);
          }

          if ($loadMoreButton.length) {
            $loadMoreButton.text($loadMoreButton.data('button-text'));
          }

          self.updateUrl.call(self, updateHistoryState, queryString);
          self.stickyMobileMenu.call(self);
          self.refreshYotpoWidgets();
        })
        .fail(function (xhr, response) {
          self.onSearchRequestError.call(self, xhr.responseJSON.message);
        })
        .always(function () {
          self.$container.addClass(classes.templateLoaded);
          self.searching = false;
        });
    },

    buildFiltersAndSort: function (response) {
      var self = this;
      response.facets.active_facets = 0;
      response.facets.forEach(function (facet) {
        facet.active_facets = 0;
        facet.values.map(function (item) {
          if (item.active) {
            response.facets.active_facets++;
            facet.active_facets++;
          }
          if (item.type == 'range') {
            item.filter_value =
              'filter.' + facet.field + '.low=' + item.low + '&' + 'filter.' + facet.field + '.high=' + item.high;
          } else if (item.type == 'value') {
            item.filter_value = 'filter.' + facet.field + '=' + item.value;
            item.label_lowercase = item.label.toLowerCase();
          }
        });

        if (facet.type == 'palette') {
          facet.palette = true;
        }
      });
      response.sorting.options.map(function (option) {
        option['sort_value'] = 'sort.' + option.field + '=' + option.direction;

        return option;
      });

      return response;
    },

    addSortOptions: function (queryString) {
      const $sortSelector = $(selectors.sortSelect);
      if ($sortSelector.length == 0) {
        return;
      }

      var sortOptionValue = $(selectors.sortSelect).val();

      if (sortOptionValue != '') {
        var sortOptionParts = sortOptionValue.split('=');
        queryString.set(sortOptionParts[0], sortOptionParts[1]);
      }
    },

    addFilters: function (queryString) {
      var self = this;
      $(selectors.filterCheckbox + ':checked').each(function (index, el) {
        if (el.value.indexOf('&')) {
          var filters_list = el.value.split('&');
          filters_list.forEach(function (filter) {
            var filter_parts = filter.split('=');
            queryString.append(filter_parts[0], filter_parts[1]);
          });
        } else {
          var filter_parts = filter.split('=');
          queryString.append(filter_parts[0], filter_parts[1]);
        }
      });
    },

    buildHeaderTemplate: function (response) {
      this.$headerContainer.html(this.headerTemplate(response));
    },

    buildResultTemplate: function (response, queryString) {
      var self = this;
      response.results.map(function (item, index) {
        if (item.is_banner) {
          return item;
        }

        if (item.msrp != 0) {
          item.msrp = slate.Currency.formatMoney(item.msrp * 100, window.theme.moneyFormat);
        } else {
          item.msrp = '';
        }

        if (item.tags) {
          const badgeTag = item.tags.find((tag) => tag.startsWith('badge:'));
          if (badgeTag) item.badge = badgeTag.slice(6);

          var isEarlyAccess = item.tags.indexOf('Early Access') != -1 || item.tags.indexOf('badge:earlyaccess') != -1;

          if (isEarlyAccess && item.ss_available === '0') {
            item.badge = 'Early Access';
            item.badge_type = 'product-card__badge--back-in-stock';
          } else if (item.ss_available === '0' && item.tags.indexOf('bis-hidden') == -1) {
            item.badge_type = 'product-card__badge--back-in-stock';
            item.badge = window.theme.strings.bisBadge;
          } else if (item.ss_available === '0') {
            item.badge = window.theme.strings.oosBadge;
          } else if (item.tags.indexOf('preorder') != -1) {
            item.badge = 'Pre-order';
            item.badge_type = 'product-card__badge--preorder';
          } else if (item.msrp != 0) {
            if (isEarlyAccess) {
              item.badge = 'Early Access';
              item.badge_type = 'product-card__badge--back-in-stock';
            } else {
              item.badge = 'Sale';
            }
          }
        }

        if (item.ss_available === '0') {
          item.sold_out = true;
        }

        item.cardIndex = 'C' + index + 'P' + response.pagination.currentPage;
        item.price = slate.Currency.formatMoney(item.price * 100, window.theme.moneyFormat);
        item.url = item.url.replace('/products/', `${document.location.pathname}/products/`);
        item.modal_url = item.url.substring(1);
        item.imageUrl = item.ss_image || item.imageUrl;

        if (
          typeof window.theme.discountMessage !== 'undefined' &&
          (window.theme.discountMessage.location == 'both' || window.theme.discountMessage.location == 'plp')
        ) {
          item.discountMessage = window.theme.discountMessage.message;
        }

        if (self.discountMessage) {
          item.discountMessage = self.discountMessage;
        }

        queryString.delete('siteId');
        queryString.delete('domain');
        queryString.delete('bgfilter.ss_is_published');
        queryString.delete('bgfilter.collection_handle');
        queryString.delete('resultsFormat');
        queryString.delete('resultsPerPage');
        item.returnUrl =
          window.location.protocol +
          '//' +
          window.location.hostname +
          window.location.pathname +
          '?' +
          queryString.toString() +
          '#' +
          item.cardIndex;
        return item;
      });
      this.$ssContainer.html(this.ssTemplate(response));
    },

    buildProductCards: function (response, queryString) {
      var self = this;
      response.results.map(function (item, index) {
        if (item.msrp != 0) {
          item.msrp = slate.Currency.formatMoney(item.msrp * 100, window.theme.moneyFormat);
        } else {
          item.msrp = '';
        }

        if (item.tags) {
          const badgeTag = item.tags.find((tag) => tag.startsWith('badge:'));
          if (badgeTag) item.badge = badgeTag.slice(6);

          var isEarlyAccess = item.tags.indexOf('Early Access') != -1 || item.tags.indexOf('badge:earlyaccess') != -1;

          if (isEarlyAccess && item.ss_available === '0') {
            item.badge = 'Early Access';
            item.badge_type = 'product-card__badge--back-in-stock';
          } else if (item.ss_available === '0' && item.tags.indexOf('bis-hidden') == -1) {
            item.badge_type = 'product-card__badge--back-in-stock';
            item.badge = window.theme.strings.bisBadge;
          } else if (item.ss_available === '0') {
            item.badge = window.theme.strings.oosBadge;
          } else if (item.tags.indexOf('preorder') != -1) {
            item.badge = 'Pre-order';
            item.badge_type = 'product-card__badge--preorder';
          } else if (item.msrp != 0) {
            if (isEarlyAccess) {
              item.badge = 'Early Access';
              item.badge_type = 'product-card__badge--back-in-stock';
            } else {
              item.badge = 'Sale';
            }
          }
        }

        if (item.ss_available === '0') {
          item.sold_out = true;
        }

        item.cardIndex = 'C' + index + 'P' + response.pagination.currentPage;
        item.price = slate.Currency.formatMoney(item.price * 100, window.theme.moneyFormat);
        item.imageUrl = item.ss_image || item.imageUrl;

        if (
          typeof window.theme.discountMessage !== 'undefined' &&
          (window.theme.discountMessage.location == 'both' || window.theme.discountMessage.location == 'plp')
        ) {
          item.discountMessage = window.theme.discountMessage.message;
        }

        queryString.delete('siteId');
        queryString.delete('domain');
        queryString.delete('bgfilter.ss_is_published');
        queryString.delete('bgfilter.collection_handle');
        queryString.delete('resultsFormat');
        queryString.delete('resultsPerPage');
        item.returnUrl =
          window.location.protocol +
          '//' +
          window.location.hostname +
          window.location.pathname +
          '?' +
          queryString.toString() +
          '#' +
          item.cardIndex;
        return item;
      });

      $(selectors.productGrid).append(self.ssResultsTemplate(response));
      if (response.pagination.nextPage != 0) {
        $(selectors.loadMoreButton)
          .attr('data-page', response.pagination.nextPage)
          .data('page', response.pagination.nextPage);
      } else {
        $(selectors.loadMoreButton).remove();
      }

      self.refreshYotpoWidgets();
    },

    buildPaginationTemplate: function (response) {
      if (response.pagination.currentPage !== 1) {
        response.pagination.prevItems = [];
        response.pagination.showFirst = true;
        response.pagination.showPrevSpacer = true;
        // Build previous pages count
        for (var i = 1; i <= 1; i++) {
          var currentPageNum = response.pagination.currentPage - i;
          if (currentPageNum > 0) {
            response.pagination.prevItems.unshift({ page_number: currentPageNum });
          }

          if (currentPageNum == 1) {
            response.pagination.showFirst = false;
            response.pagination.showPrevSpacer = false;
          }

          if (currentPageNum == 2) {
            response.pagination.showPrevSpacer = false;
          }
        }
      } else {
        response.pagination.firstPage = true;
      }
      // Build next pages count
      if (response.pagination.currentPage <= response.pagination.totalPages) {
        response.pagination.nextItems = [];
        response.pagination.showNextSpacer = true;
        response.pagination.showLast = true;
        if (response.pagination.currentPage == response.pagination.totalPages) {
          response.pagination.last_page = true;
        }

        for (var i = 1; i <= 1; i++) {
          var currentPageNum = response.pagination.currentPage + i;
          if (currentPageNum <= response.pagination.totalPages) {
            response.pagination.nextItems.push({ page_number: currentPageNum });
          }

          if (currentPageNum >= response.pagination.totalPages) {
            response.pagination.showLast = false;
          }

          if (currentPageNum >= response.pagination.totalPages - 1) {
            response.pagination.showNextSpacer = false;
          }
        }
      }

      return response;
    },

    paginateItems: function (evt) {
      evt.preventDefault();
      var $this = $(evt.currentTarget);
      var targetPageNum = $this.data('page');

      this.performSearch(true, undefined, targetPageNum, false);
    },
    scrollToCard: function () {
      var cardId = window.location.hash;
      if (cardId === '') {
        return;
      }

      var $card = $(cardId);
      if ($card.length) {
        var windowMiddle = window.innerHeight / 2; // Set middle of the screen
        var scrollPosition = $card.offset().top + $card.outerHeight() / 2 - windowMiddle;
        window.scroll({
          top: scrollPosition,
        });
      }
    },
    updateUrl: function (updateHistoryState, queryString) {
      if (updateHistoryState == false) {
        return;
      }

      queryString.delete('siteId');
      queryString.delete('domain');
      queryString.delete('bgfilter.ss_is_published');
      queryString.delete('bgfilter.collection_handle');
      queryString.delete('resultsFormat');
      queryString.delete('resultsPerPage');

      var newSearchUrl = document.location.origin + document.location.pathname + '?' + queryString.toString();

      window.history.pushState($.noop(), '', newSearchUrl);
    },

    onBrowserBackClick: function () {
      this.performSearch(false, document.location.search, undefined, false, false);
    },

    onSearchRequestError: function (response) {
      console.error('[' + this.name + '] - Search error. Message:', response);
    },

    checkScrollPosition: function () {
      if (this.scrollThreshold == 0) {
        return;
      }

      var pageHeight = document.body.scrollHeight;
      var scrollThreshold = pageHeight * (this.scrollThreshold / 100);
      var $loadMoreButton = $(selectors.loadMoreButton);
      if ($(window).scrollTop() >= scrollThreshold) {
        $loadMoreButton.trigger('click');
      }
    },

    onLoadMoreButtonClick: function (evt) {
      var $this = $(evt.currentTarget);
      var page = $this.data('page');
      $this.text('Loading...');
      this.performSearch(true, undefined, page, true);
    },

    ssTrackClick: function (evt) {
      var $this = $(evt.currentTarget);
      var intellisuggestData = $this.data('intellisuggest-data');
      var intellisuggestSignature = $this.data('intellisuggest-signature');
      if (typeof intellisuggestData != 'undefined' && typeof intellisuggestSignature != 'undefined') {
        window.intellisuggestTrackClick(evt.currentTarget, intellisuggestData, intellisuggestSignature);
      }
    },

    updateReturnState: function (evt) {
      var $this = $(evt.currentTarget);
      var returnUrl = $this.data('return-url');

      if (typeof returnUrl !== 'undefined') {
        window.history.replaceState('', document.title, returnUrl);
        window.history.scrollRestoration = 'manual';
      }
    },
    initSidebar() {
      this.$filtersSidebar = $(selectors.sidebar);

      if (this.matchMedia.matches && !this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar = new StickySidebar('.sidebar-wrapper', {
          topSpacing: 20,
          bottomSpacing: 0,
          containerSelector: '.searchspring-page__filters-sidebar',
          innerWrapperSelector: '.sidebar-filters',
        });
        this.$filtersSidebar.addClass(classes.sidebarEnabled);
      } else if (this.matchMedia.matches && this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar.updateSticky();
      } else if (!this.matchMedia.matches && this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar.destroy();
        this.$filtersSidebar.removeClass(classes.sidebarEnabled);
      }
    },
    removeFilter: function (evt) {
      var $this = $(evt.currentTarget);
      var filterToRemove = $this.data('remove-tag');
      $('input[type="checkbox"][value="' + filterToRemove + '"]')
        .prop('checked', false)
        .trigger('change');
    },
    clearFilters: function (e) {
      e.preventDefault();
      this.performSearch(true, '', 1, false, false);
    },
    onScreenResize: function () {
      this.initSidebar.call(this);
      this.stickyMobileMenu.call(this);
    },
    toggleFiltersSidebar: function () {
      $(selectors.filtersSidebar).parent().toggleClass(classes.open);
    },
    toggleFilterGroup: function (evt) {
      var $this = $(evt.currentTarget);

      $this.parent().toggleClass(classes.mobileOpen);
    },
    onSectionLoad: function () {},
  });

  return Collection;
})(jQuery);

/**
   * Collection template constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
 *
   * @namespace collection
 */
theme.CollectionShopify = (function ($) {

  var selectors = {
    sortBy: '[data-sort-by]',
    collectionUrl: '[data-collection-url]',
    filtersToggler: '[data-filter-toggler]',
    filtersSidebar: '[data-filters-sidebar]',
    filterGroup: '[data-filter-group]',
    filterGroupHeader: '[data-filter-group-header]',
    filterGroupList: '[data-filter-group-list]',
    filterItem: '[data-filter-item]',
    filter: '[data-filter]',
    mobileFilters: '[data-mobile-filters]',
    header: '[data-header]'
  };

  var classes = {
    seoLongText: 'collection-page__seo-text-description--full',
    mobileOpen: 'mobile-open',
    sidebarEnabled: 'sidebar-enabled',
    mobileSticky: 'mobile-sticky',
    open: 'is-open',
  };

  function CollectionShopify(container) {
    this.name = "collection";
    this.namespace = '.' + this.name;
    this.$container = $(container);

    // Cache dom
    this.$sortBySelect = $(selectors.sortBy, this.$container);
    this.collectionUrl = $(selectors.collectionUrl, this.$container).data('collection-url');
    this.$filters = $(selectors.filter, this.$container);
    this.$filtersToggler = $(selectors.filtersToggler, this.$container);
    this.$filtersHeader = $(selectors.filterGroupHeader, this.$container);
    this.$filtersSidebar = $(selectors.filtersSidebar, this.$container);
    this.$window = $(window);
    this.$header = $(selectors.header);
    this.loadMore = new slate.LoadMore(this.$container);
    this.$mobileFilters = $(selectors.mobileFilters, this.$container);
    this.matchMedia = window.matchMedia("(min-width: 980px)");
    this.$container.on('click', "a", this.updateCurrentState.bind(this));

    // Event listeners
    this.$sortBySelect.on('change', this.updateSortOption.bind(this));
    this.$filters.on('change', this.updateGroupSelections.bind(this));
    this.$filtersHeader.on('click', this.toggleFilterGroup.bind(this));
    this.$filtersToggler.on('click', this.toggleFiltersSidebar.bind(this));
    this.$window.on('resize', $.debounce(100, this.onResize.bind(this)));
    // Methods running on load
    this.stickyMobileMenu();
    this.initSidebar();
    this.$window.on('pageUpdated', this.updateFilterSticky.bind(this));
    document.addEventListener('load', () => this.scrollToCard());
  }

  CollectionShopify.prototype = $.extend({}, CollectionShopify.prototype, {
    scrollToCard: function() {
      var cardId = window.location.hash;
      if (cardId === "") {
        return;
      }

      var $card = $(cardId);
      var windowMiddle = window.innerHeight / 2; // Set middle of the screen
      var scrollPosition = $card.offset().top + ($card.outerHeight()/2) - windowMiddle;
      window.scroll({
        top: scrollPosition
      })
    },
    updateSortOption: function(evt) {
      var sortValue = $(evt.currentTarget).val();
      var currentUrl = window.location.pathname;

      window.location.href = currentUrl + '?sort_by=' + sortValue;
    },
    updateGroupSelections: function(evt) {
      var $this = $(evt.currentTarget);
      if($this.is(':checked')){
        var $currentGroup = $this.parents(selectors.filterGroup);
        $currentGroup.find(selectors.filter).not($this).prop('checked', false);
      }

      this.updateAppliedFilters.call(this);
    },
    updateAppliedFilters: function() {
      var self = this;
      var newUrl = this.collectionUrl;
      var filtersApplied = "";
      var activeFilters = $(selectors.filter + ':checked', this.$container);
      var params = new URL(document.location).searchParams;
      var sortOrder = params.get('sort_by');

      activeFilters.each(function(index, el) {
        if(filtersApplied !== '') {
          filtersApplied += '+' + self.__handleize($(el).val());
        } else {
          filtersApplied = self.__handleize($(el).val());
        }
      });

      newUrl += '/' + filtersApplied;
      console.warn(sortOrder);
      if(sortOrder != "" && sortOrder != null) {
        newUrl += '?sort_by=' + sortOrder;
      }

      window.location.href = newUrl;
    },
    toggleFilterGroup: function(evt) {
      var $this = $(evt.currentTarget);
      var $group = $this.parents(selectors.filterGroup);

      $group.toggleClass(classes.mobileOpen);
    },
    toggleFiltersSidebar: function(evt) {
      this.$filtersSidebar.toggleClass(classes.open);
      $('body').toggleClass('sidebar-open');
    },
    __handleize: function(str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },
    onResize(){
      this.initSidebar.call(this, this.matchMedia.matches);
      this.stickyMobileMenu.call(this, this.matchMedia.matches);
    },
    initSidebar(){
      if(this.matchMedia.matches && !this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar = new StickySidebar('.collection-page__sidebar', {
          topSpacing: 40,
          bottomSpacing: 40,
          containerSelector: '.content-container',
          innerWrapperSelector: '.sidebar-filters',
        })
        this.$filtersSidebar.addClass(classes.sidebarEnabled);
      } else if(!this.matchMedia.matches && this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar.destroy();
        this.$filtersSidebar.removeClass(classes.sidebarEnabled);
      }
    },
    updateFilterSticky() {
      this.sidebar.updateSticky();
    },
    stickyMobileMenu() {
      var headerHeight = this.$header.outerHeight();

      if(!this.matchMedia.matches) {
        this.$mobileFilters.css({'top': headerHeight});
      } else {
        this.$mobileFilters.removeAttr('style');
      }
    },
    updateCurrentState(evt) {
      var $this = $(evt.currentTarget);
      var newState =  $this.parents('.product-card').data('page-params');
      if(typeof newState != "undefined") {
        window.history.replaceState('', document.title, document.location.pathname + newState);
      }
    },
    onLoad: function() {

    }
  });

  return CollectionShopify;
})(jQuery);

/**
 * Search section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 *
 * @namespace search
 */
theme.Search = (function () {
  var selectors = {
    ssForm: '[data-searchspring-form]',
    formField: '[data-searchspring-field]',
    headerContainer: '[data-header-container]',
    mobileFilters: '[data-mobile-filters]',
    ssContainer: '[data-searchspring-container]',
    productGrid: '[data-product-grid]',
    paginationContainer: '[data-pagination-container]',
    headerTemplate: '[data-header-template]',
    ssTemplate: '[data-searchspring-template]',
    ssResultsTemplate: '[data-searchspring-results-template]',
    paginationItem: '[data-pagination-item]',
    sortSelect: '[data-sort-by]',
    filtersSidebar: '[data-filters-sidebar]',
    filtersSidebarToggler: '[data-filter-toggler]',
    filterCheckbox: '[data-filter]',
    filterGroupHeader: '[data-filter-group-header]',
    sortContainer: '[data-sort-bar-container]',
    loadMoreButton: '[data-load-more-button]',
    productGrid: '[data-product-grid]',
    sidebar: '[data-filters-sidebar]',
    removeFilterButton: '[data-remove-tag]',
    ymalTemplate: '[data-ymal-template]',
    ymalSlider: '[data-ymal]',
    header: '[data-header]',
    clearFilters: '[data-clear-filters]',
  };

  var classes = {
    templateLoaded: 'searchspring-template--loaded',
    sidebarEnabled: 'sidebar-enabled',
    open: 'is-open',
    mobileOpen: 'mobile-open',
  };

  function Search(container) {
    this.name = 'search';
    this.namespace = '.' + this.name;
    this.$container = $(container);

    this.searching = false;

    this.$ssContainer = $(selectors.ssContainer, this.$container);
    this.$resultsContainer = $(selectors.resultsContainer, this.$container);
    this.$headerContainer = $(selectors.headerContainer, this.$container);
    this.$header = $(selectors.header);
    this.$ssForm = $(selectors.ssForm, this.$container);
    this.$formField = $(selectors.formField, this.$container);
    this.queryParam = this.$formField.val();
    this.scrollThreshold = this.$container.data('scroll-position');
    this.enableLoadMore = this.$container.data('enable-load-more');

    this.headerTemplate = Handlebars.compile($(selectors.headerTemplate).html());
    this.ssTemplate = Handlebars.compile($(selectors.ssTemplate).html());
    this.ssResultsTemplate = Handlebars.compile($(selectors.ssResultsTemplate).html());
    this.ymalTemplate = Handlebars.compile($(selectors.ymalTemplate).html());

    this.$container.on('change', selectors.sortSelect, this.onFilterChange.bind(this));
    this.$container.on('change', selectors.filterCheckbox, this.onFilterChange.bind(this));
    this.$container.on('click', selectors.loadMoreButton, this.onLoadMoreButtonClick.bind(this));
    this.$container.on('click', selectors.filtersSidebarToggler, this.toggleFiltersSidebar.bind(this));
    this.$ssForm.on('submit', this.onFormSubmit.bind(this));

    this.matchMedia = window.matchMedia('(min-width: 980px)');

    this.$container.on('click', selectors.paginationItem, this.paginateItems.bind(this));
    this.$container.on('click', 'a', this.ssTrackClick.bind(this));
    this.$container.on('click', 'a', this.updateReturnState.bind(this));
    this.$container.on('click', selectors.removeFilterButton, this.removeFilter.bind(this));
    this.$container.on('click', selectors.clearFilters, this.clearFilters.bind(this));
    this.$container.on('click', selectors.filterGroupHeader, this.toggleFilterGroup.bind(this));

    $(window).on('resize', $.throttle(50, this.onScreenResize.bind(this)));
    $(window).on('popstate', this.onBrowserBackClick.bind(this));

    if (this.scrollThreshold > 0 && this.enableLoadMore) {
      $(window).on('scroll', $.throttle(50, this.checkScrollPosition.bind(this)));
    }

    this.buildUUID();
    this.performSearch(false);
  }

  Search.prototype = $.extend({}, Search.prototype, {
    refreshYotpoWidgets() {
      setTimeout(() => {
        if (typeof yotpoWidgetsContainer !== 'undefined') {
          yotpoWidgetsContainer.initWidgets();
        } else {
          this.refreshYotpoWidgets();
        }
      }, 1000);
    },
    stickyMobileMenu() {
      var headerHeight = this.$header.outerHeight();
      var $mobileFilters = $(selectors.mobileFilters, this.$container);

      if (!this.matchMedia.matches) {
        $mobileFilters.css({ top: headerHeight });
      } else {
        $mobileFilters.removeAttr('style');
      }
    },
    buildUUID: function () {
      if (typeof Cookies.get('ssSessionIdNamespace') !== 'undefined') {
        Cookies.set('ssSessionIdNamespace', uuidv4());
      }

      if (typeof Cookies.get('ssUserId') !== 'undefined') {
        Cookies.set('ssUserId', uuidv4());
      }

      Cookies.set('ssPageloadId', uuidv4());
    },

    buildQueryString: function (queryString) {
      var urlParams = new URLSearchParams(window.location.search);
      queryString = new URLSearchParams(queryString);
      queryString.set('siteId', 'do4xra');
      queryString.set('resultsFormat', 'native');
      queryString.set('domain', window.location.origin + window.location.pathname);
      queryString.set('resultsPerPage', 48);
      queryString.set('bgfilter.ss_is_published', 1);

      return queryString;
    },

    onFormSubmit: function (evt) {
      evt.preventDefault();

      this.queryParam = this.$formField.val();

      // Resests pagination in the case it was paginated before
      this.performSearch(true, this.queryParam, 1);
    },

    onFilterChange: function (evt) {
      var $this = $(evt.currentTarget);
      if ($this.is('select')) {
        $(selectors.sortSelect).val($this.val());
      }
      this.performSearch(true, this.queryParam);
    },

    performSearch: function (updateHistoryState, queryParam, targetPage, addCards, buildFilters = true) {
      var self = this;
      var queryString;

      if (this.searching == true) {
        return;
      }

      if (typeof Cookies.get('ssSessionIdNamespace') == 'undefined') {
        this.buildUUID();
      }

      if (typeof queryParam == 'undefined') {
        queryString = this.buildQueryString(document.location.search);
      } else {
        queryString = this.buildQueryString('q=' + queryParam);
        if (!buildFilters === false) {
          this.addSortOptions(queryString);
          this.addFilters(queryString);
        }
      }

      if (queryString.get('page') !== null || targetPage !== undefined) {
        queryString.set('page', targetPage || queryString.get('page'));
      } else {
        queryString.set('page', 1);
      }

      this.searching = true;

      $.ajax({
        url: 'https://do4xra.a.searchspring.io/api/search/search.json',
        method: 'GET',
        headers: {
          'searchspring-session-id': Cookies.get('ssSessionIdNamespace'),
          'searchspring-user-id': Cookies.get('ssUserId'),
          'searchspring-page-load-id': Cookies.get('ssPageloadId'),
        },
        dataType: 'JSON',
        data: queryString.toString(),
      })
        .done(function (response) {
          if (response.merchandising.redirect) {
            document.location.href = response.merchandising.redirect;
          }

          if (response.merchandising.content.header) {
            response.header_banner = response.merchandising.content.header;
          }

          if (response.merchandising.content.footer) {
            response.footer_banner = response.merchandising.content.footer;
          }

          if (response.merchandising.content.left) {
            response.left_banner = response.merchandising.content.left;
          }

          if (response.merchandising.content.inline) {
            response.merchandising.content.inline.forEach(function (item) {
              response.results.splice(item.config.position.index, 0, {
                is_banner: true,
                content: item.value,
              });
            });
          }

          response.search_param = queryString.get('q');

          if (response.results.length > 0) {
            if (addCards) {
              self.buildProductCards.call(self, response, queryString);
            } else {
              self.buildHeaderTemplate.call(self, response);
              response = self.buildFiltersAndSort.call(self, response);
              response = self.buildPaginationTemplate.call(self, response);
              self.buildResultTemplate.call(self, response, queryString);
            }
            self.initSidebar();

            if (addCards !== true) {
              $(window).scrollTop(0);
              self.scrollToCard.call(self);
            }
            self.updateUrl.call(self, updateHistoryState, queryString);
            self.stickyMobileMenu.call(self);
            document.title =
              'Search results for  ' +
              response.search_param +
              ' - Page ' +
              response.pagination.currentPage +
              ' - Chic Soul';

            self.refreshYotpoWidgets();
          } else {
            self.buildYmalModule(queryString);
          }
          self.$container.addClass(classes.templateLoaded);
        })
        .fail(function (xhr, response) {
          self.onSearchRequestError.call(self, response);
        })
        .always(function () {
          self.searching = false;
        });
    },

    buildFiltersAndSort: function (response) {
      var self = this;
      response.facets.active_facets = 0;
      response.facets.forEach(function (facet) {
        facet.active_facets = 0;
        facet.values.map(function (item) {
          if (item.active) {
            response.facets.active_facets++;
            facet.active_facets++;
          }
          if (item.type == 'range') {
            item.filter_value =
              'filter.' + facet.field + '.low=' + item.low + '&' + 'filter.' + facet.field + '.high=' + item.high;
          } else if (item.type == 'value') {
            item.filter_value = 'filter.' + facet.field + '=' + item.value;
            item.label_lowercase = item.label.toLowerCase();
          }
        });

        if (facet.type == 'palette') {
          facet.palette = true;
        }
      });
      response.sorting.options.map(function (option) {
        option['sort_value'] = 'sort.' + option.field + '=' + option.direction;

        return option;
      });

      return response;
    },

    addSortOptions: function (queryString) {
      var sortOptionValue = $(selectors.sortSelect).val();

      if (sortOptionValue != '' && sortOptionValue) {
        var sortOptionParts = sortOptionValue.split('=');
        queryString.set(sortOptionParts[0], sortOptionParts[1]);
      }
    },

    addFilters: function (queryString) {
      var self = this;
      $(selectors.filterCheckbox + ':checked').each(function (index, el) {
        if (el.value.indexOf('&')) {
          var filters_list = el.value.split('&');
          filters_list.forEach(function (filter) {
            var filter_parts = filter.split('=');
            queryString.append(filter_parts[0], filter_parts[1]);
          });
        } else {
          var filter_parts = filter.split('=');
          queryString.append(filter_parts[0], filter_parts[1]);
        }
      });
    },

    buildYmalModule: function (queryString) {
      var self = this;

      $.get('/cart.json').done(function (cart) {
        var cartData = [];
        $(cart.items).each(function (index, item) {
          cartData.push(item.sku);
        });
        var viewedProducts = Cookies.get('ss-viewed-products') || '';

        $.ajax({
          url: 'https://do4xra.a.searchspring.io/boost/do4xra/recommend',
          data: JSON.stringify({
            shopper: window.SHOPIFY_CUSTOMER_ID,
            tags: ['no-results'],
            limit: 20,
            cart: cartData,
            lastViewed: viewedProducts.split(','),
          }),
          dataType: 'JSON',
          contentType: 'application/json',
          method: 'POST',
        })
          .done(function (response) {
            self.ssRenderTrack.call(self, response);
            self.updateUrl.call(self, true, queryString);
            response.search_param = queryString.get('q');
            response[0].results.map(function (item) {
              item.stringMappings = JSON.stringify(item.mappings);
              if (item.mappings.core.msrp != 0) {
                item.mappings.core.msrp = slate.Currency.formatMoney(
                  item.mappings.core.msrp * 100,
                  window.theme.moneyFormat,
                );
              } else {
                item.mappings.core.msrp == '';
              }

              if (item.attributes.tags) {
                for (i = 0; i < item?.attributes?.tags?.length; i++) {
                  if (item.badge !== '') {
                    break;
                  }

                  if (item?.attributes?.tags?.[i].indexOf('badge:') > -1) {
                    var badge_parts = item?.attributes?.tags?.[i].split('badge:');
                    item.badge = badge_parts[1];
                  }
                }
              }

              var isEarlyAccess =
                item?.attributes?.tags?.indexOf('Early Access') > -1 ||
                item?.attributes?.tags?.indexOf('badge:earlyaccess') > -1;

              if (isEarlyAccess && item.ss_available === '0') {
                item.badge = 'Early Access';
                item.badge_type = 'product-card__badge--back-in-stock';
              } else if (
                item.ss_available === '0' &&
                item?.attributes?.tags?.length &&
                item?.attributes?.tags?.indexOf('bis-hidden') == -1
              ) {
                item.badge_type = 'product-card__badge--back-in-stock';
                item.badge = window.theme.strings.bisBadge;
              } else if (item.ss_available === '0') {
                item.badge = window.theme.strings.oosBadge;
              } else if (item.attributes?.tags?.length && item?.attributes?.tags?.indexOf('preorder') != -1) {
                item.badge = 'Pre-order';
                item.badge_type = 'product-card__badge--preorder';
              } else if (item.mappings.core.msrp != 0) {
                if (isEarlyAccess) {
                  item.badge = 'Early Access';
                  item.badge_type = 'product-card__badge--back-in-stock';
                } else {
                  item.badge = 'Sale';
                }
              }

              item.mappings.core.price = slate.Currency.formatMoney(
                item.mappings.core.price * 100,
                window.theme.moneyFormat,
              );
              item.mappings.core.imageUrl = item.attributes.ss_image || item.mappings.core.imageUrl;
              item.mappings.core.imageUrl = item.mappings.core.imageUrl.replace('600x600', '300x300');
              return item;
            });

            var ymalData = self.ymalTemplate(response[0]);

            self.$ssContainer.html(ymalData);
            self.initYmalSlider();
            self.$ssContainer.on('click', self.ssClickTrack.bind(self));
            self.buildHeaderTemplate(response);
          })
          .fail(function (xhr, response) {
            console.error(response);
          });
      });
    },

    initYmalSlider() {
      var $productYmal = $(selectors.ymalSlider);
      var slickOptions = {
        slidesToShow: 7,
        slidesToScroll: 5,
        infinite: false,
        dots: true,
        prevArrow: '.search__ymal-header [data-arrow-prev]',
        nextArrow: '.search__ymal-header [data-arrow-next]',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 6.2,
            },
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 2,
            },
          },
        ],
      };

      $productYmal.not('.slick-initialized').slick(slickOptions);
      this.$container.addClass(classes.searchPerformed);
    },

    ssRenderTrack: function (response) {
      var commonId = uuidv4();
      var beaconData = [
        {
          type: 'profile.render',
          category: 'searchspring.recommendations.user-interactions',
          id: commonId,
          pid: null,
          event: {
            profile: {
              tag: 'no-results',
              placement: 'other',
            },
            context: {
              type: 'product-recommendation',
              tag: 'no-results',
              placement: 'other',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        },
      ];

      response[0].results.forEach(function (item) {
        var productRenderData = {
          type: 'profile.product.render',
          category: 'searchspring.recommendations.user-interactions',
          id: uuidv4(),
          pid: commonId,
          event: {
            product: {
              id: item.id,
              mappings: item.mappings,
            },
            context: {
              type: 'product-recommendation',
              tag: 'no-results',
              placement: 'other',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        };

        beaconData.push(productRenderData);
      });

      beaconData.forEach(function (item) {
        if (item.type == 'profile.render') {
          var newType = 'profile.impression';
        } else if (item.type == 'profile.product.render') {
          var newType = 'profile.product.impression';
        }
        var impressionData = Object.assign({}, item, {
          type: newType,
          id: uuidv4(),
          pid: commonId,
        });

        beaconData.push(impressionData);
      });
      $.ajax({
        url: 'https://beacon.searchspring.io/beacon',
        dataType: 'JSON',
        data: JSON.stringify(beaconData),
        contentType: 'application/json',
        method: 'POST',
      });
    },

    ssClickTrack: function (evt) {
      var $target = $(evt.target);
      var $card = $target.closest(selectors.searchSrpingProduct);
      var commonId = uuidv4();
      var beaconData = [
        {
          type: 'profile.click',
          category: 'searchspring.recommendations.user-interactions',
          id: commonId,
          pid: null,
          event: {
            profile: {
              tag: 'no-results',
              placement: 'other',
            },
            context: {
              type: 'product-recommendation',
              tag: 'no-results',
              placement: 'other',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        },
      ];

      if ($card.length > 0) {
        var productId = $card.data('product-id');
        var mappings = $card.data('product-data');
        var productClick = {
          type: 'profile.product.click',
          category: 'searchspring.recommendations.user-interactions',
          id: uuidv4(),
          pid: commonId,
          event: {
            product: {
              id: productId,
              mappings: mappings,
            },
            context: {
              type: 'product-recommendation',
              tag: 'product-page',
              placement: 'other',
            },
          },
          context: {
            website: { trackingCode: 'do4xra' },
            userId: Cookies.get('ssUserId'),
            sessionId: Cookies.get('ssSessionIdNamespace'),
            pageLoadId: Cookies.get('ssPageloadId'),
          },
        };

        beaconData.push(productClick);
      }
      ga('send', 'event', 'personalized-recommendations', 'recommendations-click', 'also-viewed');

      $.ajax({
        url: 'https://beacon.searchspring.io/beacon',
        dataType: 'JSON',
        data: JSON.stringify(beaconData),
        contentType: 'application/json',
        method: 'POST',
      });
    },

    buildHeaderTemplate: function (response) {
      this.$headerContainer.html(this.headerTemplate(response));
    },

    buildResultTemplate: function (response, queryString) {
      var self = this;
      response.results.map(function (item, index) {
        if (item.is_banner) {
          return item;
        }

        if (item.msrp != 0) {
          item.msrp = slate.Currency.formatMoney(item.msrp * 100, window.theme.moneyFormat);
        } else {
          item.msrp = '';
        }

        if (item.tags) {
          const badgeTag = item.tags.find((tag) => tag.startsWith('badge:'));
          if (badgeTag) item.badge = badgeTag.slice(6);

          var isEarlyAccess = item.tags.indexOf('Early Access') != -1 || item.tags.indexOf('badge:earlyaccess') != -1;

          if (isEarlyAccess && item.ss_available === '0') {
            item.badge = 'Early Access';
            item.badge_type = 'product-card__badge--back-in-stock';
          } else if (item.ss_available === '0' && item.tags.indexOf('bis-hidden') == -1) {
            item.badge_type = 'product-card__badge--back-in-stock';
            item.badge = window.theme.strings.bisBadge;
          } else if (item.ss_available === '0') {
            item.badge = window.theme.strings.oosBadge;
          } else if (item.tags.indexOf('preorder') != -1) {
            item.badge = 'Pre-order';
            item.badge_type = 'product-card__badge--preorder';
          } else if (item.msrp != 0) {
            if (isEarlyAccess) {
              item.badge = 'Early Access';
              item.badge_type = 'product-card__badge--back-in-stock';
            } else {
              item.badge = 'Sale';
            }
          }
        }

        if (item.ss_available === '0') {
          item.sold_out = true;
        }

        item.cardIndex = 'C' + index + 'P' + response.pagination.currentPage;
        item.price = slate.Currency.formatMoney(item.price * 100, window.theme.moneyFormat);
        item.modal_url = item.url.substring(1);
        item.imageUrl = item.ss_image || item.imageUrl;

        if (
          typeof window.theme.discountMessage !== 'undefined' &&
          (window.theme.discountMessage.location == 'both' || window.theme.discountMessage.location == 'plp')
        ) {
          item.discountMessage = window.theme.discountMessage.message;
        }

        if (
          typeof window.theme.tagDiscountMessage !== 'undefined' &&
          (window.theme.tagDiscountMessage.location == 'both' || window.theme.tagDiscountMessage.location == 'plp')
        ) {
          item.discountMessage = item?.tags?.find(function (tag) {
            return tag.indexOf('DM:') > -1;
          });
          item.discountMessage = item.discountMessage?.replace('DM:', '');
        }

        queryString.delete('siteId');
        queryString.delete('domain');
        queryString.delete('bgfilter.ss_is_published');
        queryString.delete('bgfilter.collection_handle');
        queryString.delete('resultsFormat');
        queryString.delete('resultsPerPage');
        item.returnUrl =
          window.location.protocol +
          '//' +
          window.location.hostname +
          window.location.pathname +
          '?' +
          queryString.toString() +
          '#' +
          item.cardIndex;
        return item;
      });
      this.$ssContainer.html(this.ssTemplate(response));
    },

    buildProductCards: function (response, queryString) {
      var self = this;
      response.results.map(function (item, index) {
        if (item.msrp != 0) {
          item.msrp = slate.Currency.formatMoney(item.msrp * 100, window.theme.moneyFormat);
        } else {
          item.msrp = '';
        }

        if (item.tags) {
          const badgeTag = item.tags.find((tag) => tag.startsWith('badge:'));
          if (badgeTag) item.badge = badgeTag.slice(6);

          var isEarlyAccess = item.tags.indexOf('Early Access') != -1 || item.tags.indexOf('badge:earlyaccess') != -1;

          if (isEarlyAccess && item.ss_available === '0') {
            item.badge = 'Early Access';
            item.badge_type = 'product-card__badge--back-in-stock';
          } else if (item.ss_available === '0' && item.tags.indexOf('bis-hidden') == -1) {
            item.badge_type = 'product-card__badge--back-in-stock';
            item.badge = window.theme.strings.bisBadge;
          } else if (item.ss_available === '0') {
            item.badge = window.theme.strings.oosBadge;
          } else if (item.tags.indexOf('preorder') != -1) {
            item.badge = 'Pre-order';
            item.badge_type = 'product-card__badge--preorder';
          } else if (item.msrp != 0) {
            if (isEarlyAccess) {
              item.badge = 'Early Access';
              item.badge_type = 'product-card__badge--back-in-stock';
            } else {
              item.badge = 'Sale';
            }
          }
        }

        if (item.ss_available === '0') {
          item.sold_out = true;
        }

        item.cardIndex = 'C' + index + 'P' + response.pagination.currentPage;
        item.price = slate.Currency.formatMoney(item.price * 100, window.theme.moneyFormat);
        item.modal_url = item.url.substring(1);
        item.imageUrl = item.ss_image || item.imageUrl;

        if (
          typeof window.theme.discountMessage !== 'undefined' &&
          (window.theme.discountMessage.location == 'both' || window.theme.discountMessage.location == 'plp')
        ) {
          item.discountMessage = window.theme.discountMessage.message;
        }

        if (
          typeof window.theme.tagDiscountMessage !== 'undefined' &&
          (window.theme.tagDiscountMessage.location == 'both' || window.theme.tagDiscountMessage.location == 'plp')
        ) {
          item.discountMessage = item.tags?.find(function (tag) {
            return tag.indexOf('DM:') > -1;
          });
          item.discountMessage = item.discountMessage?.replace('DM:', '');
        }

        queryString.delete('siteId');
        queryString.delete('domain');
        queryString.delete('bgfilter.ss_is_published');
        queryString.delete('bgfilter.collection_handle');
        queryString.delete('resultsFormat');
        queryString.delete('resultsPerPage');
        item.returnUrl =
          window.location.protocol +
          '//' +
          window.location.hostname +
          window.location.pathname +
          '?' +
          queryString.toString() +
          '#' +
          item.cardIndex;
        return item;
      });

      $(selectors.productGrid).append(self.ssResultsTemplate(response));
      if (response.pagination.nextPage != 0) {
        $(selectors.loadMoreButton)
          .attr('data-page', response.pagination.nextPage)
          .data('page', response.pagination.nextPage);
      } else {
        $(selectors.loadMoreButton).remove();
      }

      self.refreshYotpoWidgets();
    },

    buildPaginationTemplate: function (response) {
      if (response.pagination.currentPage !== 1) {
        response.pagination.prevItems = [];
        response.pagination.showFirst = true;
        response.pagination.showPrevSpacer = true;
        // Build previous pages count
        for (var i = 1; i <= 1; i++) {
          var currentPageNum = response.pagination.currentPage - i;
          if (currentPageNum > 0) {
            response.pagination.prevItems.unshift({ page_number: currentPageNum });
          }

          if (currentPageNum == 1) {
            response.pagination.showFirst = false;
            response.pagination.showPrevSpacer = false;
          }

          if (currentPageNum == 2) {
            response.pagination.showPrevSpacer = false;
          }
        }
      } else {
        response.pagination.firstPage = true;
      }
      // Build next pages count
      if (response.pagination.currentPage <= response.pagination.totalPages) {
        response.pagination.nextItems = [];
        response.pagination.showNextSpacer = true;
        response.pagination.showLast = true;
        if (response.pagination.currentPage == response.pagination.totalPages) {
          response.pagination.last_page = true;
        }

        for (var i = 1; i <= 1; i++) {
          var currentPageNum = response.pagination.currentPage + i;
          if (currentPageNum <= response.pagination.totalPages) {
            response.pagination.nextItems.push({ page_number: currentPageNum });
          }

          if (currentPageNum >= response.pagination.totalPages) {
            response.pagination.showLast = false;
          }

          if (currentPageNum >= response.pagination.totalPages - 1) {
            response.pagination.showNextSpacer = false;
          }
        }
      }

      return response;
    },

    paginateItems: function (evt) {
      evt.preventDefault();
      var $this = $(evt.currentTarget);
      var targetPageNum = $this.data('page');

      this.performSearch(true, this.queryParam, targetPageNum);
    },
    scrollToCard: function () {
      var cardId = window.location.hash;
      if (cardId === '') {
        return;
      }

      var $card = $(cardId);
      var windowMiddle = window.innerHeight / 2; // Set middle of the screen
      var scrollPosition = $card.offset().top + $card.outerHeight() / 2 - windowMiddle;
      window.scroll({
        top: scrollPosition,
      });
    },
    updateUrl: function (updateHistoryState, queryString) {
      if (updateHistoryState == false) {
        return;
      }

      queryString.delete('siteId');
      queryString.delete('domain');
      queryString.delete('bgfilter.ss_is_published');
      queryString.delete('resultsFormat');
      queryString.delete('resultsPerPage');

      var newSearchUrl = document.location.origin + document.location.pathname + '?' + queryString.toString();

      var pageTitle = 'Search results for ' + queryString.get('q');

      window.history.pushState($.noop(), pageTitle, newSearchUrl);
    },

    onBrowserBackClick: function () {
      this.performSearch(false);
    },

    onSearchRequestError: function (response) {
      console.error('[' + this.name + '] - Search error. Message: ', response);
    },

    checkScrollPosition: function () {
      if (this.scrollThreshold == 0) {
        return;
      }

      var pageHeight = document.body.scrollHeight;
      var scrollThreshold = pageHeight * (this.scrollThreshold / 100);
      var $loadMoreButton = $(selectors.loadMoreButton);
      if ($(window).scrollTop() >= scrollThreshold) {
        $loadMoreButton.trigger('click');
      }
    },

    onLoadMoreButtonClick: function (evt) {
      var $this = $(evt.currentTarget);
      var page = $this.data('page');
      $this.text('Loading...');
      this.performSearch(true, undefined, page, true);
    },

    ssTrackClick: function (evt) {
      var $this = $(evt.currentTarget);
      var intellisuggestData = $this.data('intellisuggest-data');
      var intellisuggestSignature = $this.data('intellisuggest-signature');
      if (typeof intellisuggestData != 'undefined' && typeof intellisuggestSignature != 'undefined') {
        window.intellisuggestTrackClick(evt.currentTarget, intellisuggestData, intellisuggestSignature);
      }
    },

    updateReturnState: function (evt) {
      var $this = $(evt.currentTarget);
      var returnUrl = $this.data('return-url');

      if (typeof returnUrl !== 'undefined') {
        window.history.replaceState('', document.title, returnUrl);
        window.history.scrollRestoration = 'manual';
      }
    },
    initSidebar() {
      this.$filtersSidebar = $(selectors.sidebar);

      if (this.matchMedia.matches && !this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar = new StickySidebar('.sidebar-wrapper', {
          topSpacing: 20,
          bottomSpacing: 0,
          containerSelector: '.searchspring-page__filters-sidebar',
          innerWrapperSelector: '.sidebar-filters',
        });
        this.$filtersSidebar.addClass(classes.sidebarEnabled);
      } else if (this.matchMedia.matches && this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar.updateSticky();
      } else if (!this.matchMedia.matches && this.$filtersSidebar.hasClass(classes.sidebarEnabled)) {
        this.sidebar.destroy();
        this.$filtersSidebar.removeClass(classes.sidebarEnabled);
      }
    },
    removeFilter: function (evt) {
      var $this = $(evt.currentTarget);
      var filterToRemove = $this.data('remove-tag');
      $('input[type="checkbox"][value="' + filterToRemove + '"]')
        .prop('checked', false)
        .trigger('change');
    },
    clearFilters: function (e) {
      e.preventDefault();
      this.performSearch(true, this.queryParam, 1, false, false);
    },
    onScreenResize: function () {
      this.initSidebar.call(this);
      this.stickyMobileMenu.call(this);
    },
    toggleFiltersSidebar: function () {
      $(selectors.filtersSidebar).parent().toggleClass(classes.open);
    },
    toggleFilterGroup: function (evt) {
      var $this = $(evt.currentTarget);

      $this.parent().toggleClass(classes.mobileOpen);
    },
    onSectionLoad: function () {},
  });

  return Search; // where does this get executed?
})();

/**
   * Four04 section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
 *
   * @namespace 404
 */
 theme.Four04 = (function () {

  var selectors = {
    ymalContainer: '[data-ymal]',
    ymalTemplate: '[data-ymal-template]',
  };

  var classes = {
  };


  function Four04(container) {
    this.name = "404";
    this.namespace = "." + this.name;
    this.$container = $(container);
    // cache DOM
    this.$ymalContainer = $(selectors.ymalContainer, this.$container);
    this.$

    this.$ymalContainer.on('click', this.ssClickTrack.bind(this));

    this.initProductYmal();
  }

  Four04.prototype = $.extend({}, Four04.prototype, {
    initProductYmal() {
      var self = this;
      $.get('/cart.json').done(function(cart) {
        var cartData = [];
        $(cart.items).each(function(index, item) {
          cartData.push(item.sku);
        })
        var viewedProducts = Cookies.get('ss-viewed-products') || "";

        $.ajax(
            {
              url: 'https://do4xra.a.searchspring.io/boost/do4xra/recommend',
              data: JSON.stringify({
                'shopper': window.SHOPIFY_CUSTOMER_ID,
                'tags': ['404'],
                'limit': 20,
                'cart': cartData,
                'lastViewed': viewedProducts.split(','),
              }),
              dataType: 'JSON',
              contentType: 'application/json',
              method: 'POST',
            }
          )
          .done(function(response) {
            self.ssRenderTrack.call(self, response);
            response[0].results.map(function(item) {
              item.stringMappings = JSON.stringify(item.mappings);
              if (item.mappings.core.msrp != 0) {
                item.mappings.core.msrp = slate.Currency.formatMoney(item.mappings.core.msrp * 100, window.theme.moneyFormat);
              } else {
                item.mappings.core.msrp == '';
              }

              if(item.attributes.tags) {
                for(i = 0; i < item.attributes.tags.length; i++) {
                  if(item.badge !== "") {
                    break;
                  }

                  if(item.attributes.tags[i].indexOf('badge:')) {
                    var badge_parts = item.attributes.tags[i].split('badge:');
                    item.badge = badge_parts[1];
                  }
                }
              }

              if(item.ss_available === "0" && item.attributes.tags.length && item.attributes.tags.indexOf('bis-hidden') == -1) {
                item.badge = window.theme.strings.bisBadge;
                item.badge_type = "product-card__badge--back-in-stock";
              } else if(item.ss_available === "0"){
                item.badge = window.theme.strings.oosBadge;
              } else if(item.attributes.tags.length && item.attributes.tags.indexOf('preorder') != -1) {
                item.badge = 'Pre-order';
                item.badge_type = 'product-card__badge--preorder';
              } else if (item.mappings.core.msrp != 0) {
                item.badge = 'Sale'
              }

              item.mappings.core.price = slate.Currency.formatMoney(item.mappings.core.price * 100, window.theme.moneyFormat);
              item.mappings.core.imageUrl = item.attributes.ss_image || item.mappings.core.imageUrl;
              item.mappings.core.imageUrl = item.mappings.core.imageUrl.replace('600x600', '300x300');
              return item;
            });

            var ymalTemplate =  Handlebars.compile($(selectors.ymalTemplate).html())
            var ymalData = ymalTemplate(response[0]);


            self.$ymalContainer.html(ymalData)
            self.initYmalSlider();
          })
          .fail(function(xhr, response) {
             console.error(response)
          })
      });
    },

    initYmalSlider() {
        var dataProductYmal = $('[data-product-ymal]')
        var slickOptions = {
          slidesToShow: 7,
          slidesToScroll: 5,
          infinite: false,
          dots: true,
          prevArrow: '.featured-collection [data-arrow-prev]',
          nextArrow: '.featured-collection [data-arrow-next]',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 6.2,
              }
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 4,
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 2.2,
                slidesToScroll: 2,
              }
            }
          ]
        }

        this.$ymalContainer.not('.slick-initialized').slick(slickOptions);
    },
    ssRenderTrack: function(response) {
      var self = this;
      var commonId = uuidv4();
      var beaconData = [{
        "type": "profile.render",
        "category": "searchspring.recommendations.user-interactions",
        "id": commonId,
        "pid": null,
        "event": {
          "profile": {
            "tag": "404",
            "placement": "other",
          },
          "context": {
            "type": "product-recommendation",
            "tag": "404",
            "placement": "other"
          },
        },
        "context": {
          "website": {"trackingCode": "do4xra"},
          "userId": Cookies.get('ssUserId'),
          "sessionId": Cookies.get('ssSessionIdNamespace'),
          "pageLoadId": Cookies.get('ssPageloadId')
        }
      }];

      response[0].results.forEach(function(item) {
        var productRenderData = {
          "type": "profile.product.render",
          "category": "searchspring.recommendations.user-interactions",
          "id": uuidv4(),
          "pid": commonId,
          "event": {
            "product": {
              "id": item.id,
              "mappings": item.mappings
            },
            "context": {
              "type": "product-recommendation",
              "tag": "product-page",
              "placement": "other"
            }
          },
          "context": {
            "website": {"trackingCode": "do4xra"},
            "userId": Cookies.get('ssUserId'),
            "sessionId": Cookies.get('ssSessionIdNamespace'),
            "pageLoadId": Cookies.get('ssPageloadId')
          }
        }

        beaconData.push(productRenderData);
      });

      beaconData.forEach(function(item) {
        if(item.type == 'profile.render') {
          var newType = 'profile.impression'
        } else if (item.type == 'profile.product.render') {
          var newType = 'profile.product.impression';
        }
        var impressionData = Object.assign({}, item, {
          type: newType,
          id: uuidv4(),
          pid: commonId
        })

        beaconData.push(impressionData);
      });
      $.ajax({
        url: 'https://beacon.searchspring.io/beacon',
        dataType: 'JSON',
        data: JSON.stringify(beaconData),
        contentType: 'application/json',
        method: 'POST',
      });
    },
    ssClickTrack: function(evt) {
      var $target = $(evt.target);
      var $card = $target.closest(selectors.searchSrpingProduct);
      var commonId = uuidv4();
      var beaconData = [{
        "type": "profile.click",
        "category": "searchspring.recommendations.user-interactions",
        "id": commonId,
        "pid": null,
        "event": {
          "profile": {
            "tag": "404",
            "placement": "other",
          },
          "context": {
            "type": "product-recommendation",
            "tag": "404",
            "placement": "other"
          },
        },
        "context": {
          "website": {"trackingCode": "do4xra"},
          "userId": Cookies.get('ssUserId'),
          "sessionId": Cookies.get('ssSessionIdNamespace'),
          "pageLoadId": Cookies.get('ssPageloadId')
        }
      }];
      if($card.length > 0) {
        var productId = $card.data('product-id');
        var mappings = $card.data('product-data');
        var productClick = {
          "type": "profile.product.click",
          "category": "searchspring.recommendations.user-interactions",
          "id": uuidv4(),
          "pid": commonId,
          "event": {
            "product": {
              "id": productId,
              "mappings": mappings
            },
            "context": {
              "type": "product-recommendation",
              "tag": "product-page",
              "placement": "other"
            }
          },
          "context": {
            "website": {"trackingCode": "do4xra"},
            "userId": Cookies.get('ssUserId'),
            "sessionId": Cookies.get('ssSessionIdNamespace'),
            "pageLoadId": Cookies.get('ssPageloadId')
          }
        }

        beaconData.push(productClick);
      }
      ga('send', 'event', 'personalized-recommendations', 'recommendations-click', 'also-viewed');
      $.ajax({
        url: 'https://beacon.searchspring.io/beacon',
        dataType: 'JSON',
        data: JSON.stringify(beaconData),
        contentType: 'application/json',
        method: 'POST',
      });
    }
  });

  return Four04; // where does this get executed?
})();



$(document).ready(function() {
  // register sections
  var sections = new slate.Sections();
  sections.register("header-section", theme.Header);
  sections.register("footer", theme.Footer);
  sections.register("modal", theme.Modal);
  sections.register("product", theme.Product);
  sections.register("accordion", theme.Accordion);
  sections.register("video", theme.Video);
  sections.register("featured-collection", theme.FeaturedCollection);
  sections.register("zoom-gallery", theme.ZoomGallery);
  sections.register("collection-template", theme.Collection);
  sections.register('swatches', theme.Swatches);
  sections.register("search-template", theme.Search);
  sections.register("birthday-capture", theme.BirthdayCapture);
  sections.register("four-o-four", theme.Four04);
  sections.register("collection-shopify-template", theme.CollectionShopify);

  var $document = $(document);

  // Cart Init
  slate.cart.init();

  // Gift card recipient form (gift card PDP)
  theme.GiftCardRecipient.init();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace("supports-no-cookies","supports-cookies");
  }

  $('select').not('.chosen-disabled').chosen();

  // init flatpickr datepicker
  $('[data-flatpickr]').flatpickr({
    dateFormat: 'm/d/Y',
    maxDate: "today",
  })

  $('[data-flatpickr]').on('change', function() {
    var $this = $(this);
    var $siblings = $this.siblings('input[type=date]');
    if($this.val() !== '') {
      $this.removeAttr('placeholder');
      $siblings.removeAttr('placeholder');
    } else {
      if($this.parents('footer').length) {
        $this.attr('placeholder', 'Birthday (MM/DD/YYYY)');
        $siblings.attr('placeholder', 'Birthday (MM/DD/YYYY)');
      } else {
        $this.attr('placeholder', 'mm/dd/yyyy');
        $siblings.attr('placeholder', 'mm/dd/yyyy');
      }
    }
  })

  // Responsive navigation, turns a regular nav into a select item
  $('[data-responsive-navigation] a').each(function(index, el) {
    var currentTarget = false;
    var navItemUrl = $(el).attr('href');
    var navItemText = $(el).text();
    if ($(el).hasClass('current')) {
      currentTarget = true;
    }
    if(currentTarget){
      $('[data-responsive-navigation]').siblings('[data-responsive-navigation-mobile]').append('<option value="'+navItemUrl+'" selected="'+currentTarget+'">'+navItemText+'</option>')
    }else {
      $('[data-responsive-navigation]').siblings('[data-responsive-navigation-mobile]').append('<option value="'+navItemUrl+'">'+navItemText+'</option>')
    }
    $('[data-responsive-navigation]').siblings('[data-responsive-navigation-mobile]').trigger('chosen:updated');
  });

  $document.on('change', '[data-responsive-navigation-mobile]', function(evt) {
    var $this = $(evt.currentTarget);
    var newUrl = $this.val();

    window.location.href = newUrl;
  });

  // End of responsive navigation

  // form validation
  $('form').on('submit', window.slate.utils.validateForm.bind(this));
  $('input').on('blur', window.slate.utils.validateField.bind(this));
  $('input').on('keyup', function(e){
    var $field = $(e.currentTarget);

    if ($field.hasClass('has-error')) {
      $field.removeClass('has-error');
    }
  })

  // Watch for birthday field
  $('[name="customer[note][Birthday]"]').on('change', function(evt) {
    var $this = $(evt.currentTarget);
    var birthday = $this.val();
    if(birthday != false) {
      Cookies.set('customerBirthday', birthday);
      Cookies.remove('birthdaySent');
    } else {
      Cookies.remove('customerBirthday');
    }
  })
  // Watch for phone field
  $('[data-phone-number]').on('input', function(evt) {
    var phoneVal = $(evt.target).val().replace(/(\D+)/g, '').match(/(\d{0,3})(\d{0,7})/);

    if(phoneVal[1] !== '') {
      $(evt.target).val(!phoneVal[2] ? '(' + phoneVal[1] : '(' + phoneVal[1] + ') ' + phoneVal[2]);
    } else {
      $(evt.target).val('');
    }
  })
  $('[data-phone-number]').on('change', function(evt) {
    var $this = $(evt.currentTarget);
    var phone = $this.val();
    phone = phone.replace('+1', '').replace(/\D/g, '');

    phone = '+1' + phone;
    Cookies.set('cs_customerPhone', phone);
  })

  if(typeof window.customer !== 'undefined') {
    var customerBirthday = Cookies.get('customerBirthday');
    var acceptsMarketing = window.customer.acceptsMarketing;
    if(typeof Cookies.get('birthdaySent') === 'undefined' && typeof customerBirthday !== 'undefined') {
      const options = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2024-02-15'
        },
        body: JSON.stringify({
          data: {
            "type": "profile",
            "attributes": {
              "email": window.customer.email,
              "properties": {
                "$birthday": customerBirthday
              }
            },
          }
        })
      };

      fetch('https://a.klaviyo.com/client/profiles/?company_id=PaitnH', options)
      .then( function(data) {
        Cookies.set('birthdaySent', true);
      })
    }
    if(typeof Cookies.get('addedToMarketing') == 'undefined' && acceptsMarketing) {
      $.ajax({
        url: 'https://a.klaviyo.com/client/subscriptions/?company_id=PaitnH',
        method: 'POST',
        headers: {
          'accepts': 'application/json',
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          'revision': '2024-02-15',
        },
        data: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Customer Subscription Form',
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: window.customer.email,
                    phone_number: customerPhone,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'LzCgke'
                }
              }
            }
          }
        })
      })
      .done( function(data) {
        Cookies.set('addedToMarketing', true);
      })
    }

    var customerPhone = Cookies.get('cs_customerPhone');
    if(typeof Cookies.get('cs_phoneSent') == 'undefined' && typeof customerPhone !== 'undefined' && acceptsMarketing) {
      console.log('Submitting SMS consent');
      $.ajax({
        url: 'https://a.klaviyo.com/client/subscriptions/?company_id=PaitnH',
        method: 'POST',
        headers: {
          'accepts': 'application/json',
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          'revision': '2024-02-15',
        },
        data: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Customer Subscription',
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: window.customer.email,
                    phone_number: customerPhone,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'TneGit'
                }
              }
            }
          }
        })
      })
      .done( function(data) {
        Cookies.set('cs_phoneSent', true);
      })
    }
  }



  //Smooth Scroll
  $(document).on("click", "[data-smooth-scroll]", function (e){
    e.preventDefault()
    $("[data-smooth-scroll]").removeClass('active')
    $(this).addClass('active');
    var scrollElement = $(this).attr('href')


    document.querySelector(scrollElement).scrollIntoView();
  })

  // IntelliSuggest click tracking
  window.intellisuggestTrackClick = function (element, data, signature) {
    var escapeFn = encodeURIComponent || escape;

    if(document.images) {
      if ('https:' == location.protocol) {
        var api_url = 'https://do4xra.a.searchspring.io/api/';
      } else {
        var api_url = 'http://do4xra.a.searchspring.io/api/';
      }

      var imgTag = new Image;
      imgTag.src= api_url+'track/track.json?d='+data+'&s='+signature+'&u='+escapeFn(element.href)+'&r='+escapeFn(document.referrer);
    }

      return true;
  }

  if (document.location.hash) {
      setTimeout(function() {
          window.scrollTo(window.scrollX, window.scrollY - 100);
      }, 10);
  }

});